import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged, finalize, forkJoin, lastValueFrom, Subject, take, takeUntil } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { MenuSelectionService } from 'src/app/services/MenuSelectionService.service';
import { PosSettingsService } from 'src/app/services/pos-settings.service';
import { PosSalesService } from 'src/app/services/possalesservice';
import { SalesPersonService } from 'src/app/services/SalesPerson.service';
import { UserService } from 'src/app/services/User.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { IVendorsFilterOptions } from 'src/app/Shared/model/VendorsModel';
import { POSCustomerSearchComponent } from 'src/app/Shared/pos-customer-search/pos-customer-search.component';
import { POSVendorSearchComponent } from 'src/app/Shared/pos-vendor-search/pos-vendor-search.component';
import { RemoveCurrencyFormattingDirective } from 'src/app/Shared/remove-Currency-Formatting.directive';
import { ANGULAR_MODULES, Pos_COMPONENTS, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { TopBarComponent } from "src/app/top-bar/top-bar.component";
import Swal from 'sweetalert2';
import { POSShipperSearchComponent } from '../pos-shipper-search/pos-shipper-search.component';
import { PosPayment } from '../pos-payment/pos-payment';
import { NumericInputDirective } from 'src/app/Shared/numeric-input.directive';
import { PassCodeAuthentication } from 'src/app/Shared/passcodeAuthentication/passcode-Authentication.component';
import { PosOpeningCashDrawerService } from 'src/app/services/pos_OpeningCashDrawer.service';
import { IOpenCashModel } from 'src/app/Shared/Interfaces/IPOSSettings';
import { OpsOpeningCashDrawerAmount } from 'src/app/operations/ops-point-of-sales/ops-opening-cash-drawer-amount/ops-opening-cash-drawer-amount';
import printJS from 'print-js';
import { DomSanitizer } from '@angular/platform-browser';
import { PrinterSettingsService } from 'src/app/services/printer-settings.service';
import { PercentageFormatterDirective } from 'src/app/Shared/percentageFormatter.directive';
import { CommonCalculatorService } from 'src/app/Shared/commonCalculators.service';
import { CurrencyFormatterDirective } from 'src/app/Shared/currencyFormatter.directive';
import { CreditCardTypeService } from 'src/app/services/creditcardtype';
import { PaymentService } from 'src/app/services/payment.service';
import { PaymentComponent } from 'src/app/Shared/payment/payment.component';
import { DayEndService } from 'src/app/services/DayEnd.service';
import { ConsignmentService } from 'src/app/services/Consignment.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { CurrencyInputDirective } from 'src/app/Shared/currency-input.directive';
import { GiftCertificatesService } from 'src/app/services/gift-certificates.service';
import { NegativePositiveNumberDirective } from 'src/app/Shared/negative-positive-number.directive';
import { PhoneFormatPipe } from 'src/app/Shared/phone-format.pipe';
import { EnterAsTabDirective } from 'src/app/Shared/enterAsTab.directive';
import { RequireBeforeAdvanceDirective } from 'src/app/Shared/requireBeforeAdvance.directive';

declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-pos-sales-details',
  standalone: true,
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, Pos_COMPONENTS,
    TopBarComponent, LoaderComponent, WordReplacePipe, POSVendorSearchComponent, POSCustomerSearchComponent,
    RemoveCurrencyFormattingDirective, VendorSearchComponent, POSShipperSearchComponent, PosPayment, NumericInputDirective, PassCodeAuthentication,
    OpsOpeningCashDrawerAmount, PercentageFormatterDirective, customCurrencyPipe, CurrencyFormatterDirective, PaymentComponent, CurrencyInputDirective,
    NegativePositiveNumberDirective, PhoneFormatPipe, EnterAsTabDirective, RequireBeforeAdvanceDirective],
  templateUrl: './pos-sales-details.html',
  styleUrl: './pos-sales-details.scss'
})
export class PosSalesDetails implements OnInit, AfterViewInit {
  hideOpenCashTopMenu = false;
  public loaderIcon: Promise<boolean>;
  private destroy$ = new Subject<void>();
  customerItemList = [];
  loadedOrgItemList = []
  invoiceNo;
  vendorDiscountList = [];
  inventoryItemDiscount: number | null = null; // Discount % configured on the inventory item itself

  // Options for the Disc (%) dropdown: the inventory item's own discount (if any) plus the vendor plans.
  // vendorDiscountList stays vendor-only because applyBestDiscount relies on it.
  get discountOptions(): any[] {
    const inv = Number(this.inventoryItemDiscount);
    const hasInventoryOption = inv > 0 && this.discountAllPercent == null
      && !this.vendorDiscountList.some(d => Number(d?.DiscountPercent) === inv);
    return hasInventoryOption
      ? [{ DiscountPercent: inv, PlanName: 'Inventory Discount' }, ...this.vendorDiscountList]
      : this.vendorDiscountList;
  }
  vendorDiscountText = "";
  discountAllPercent: number | null = null;
  currentMenu = '1';
  bindNewGCData = false;
  itemVoidorRetn = false;
  selectedOptionBeforePasscodeAuth;
  cancelLayawaySaleClicked = false;
  hideVoidButton = false;
  savedReturnReason = ''; // reason already recorded on a returned/voided invoice - not editable
  displayChangeCardType = false;
  paymentData;
  customerDataPopup = false;
  lastInvoiceofUser = "";
  @ViewChild('vendorModal', { static: false }) vendorModal: ElementRef;
  @ViewChild('customerModal', { static: false }) customerModal: ElementRef;
  @ViewChild('shipperModal', { static: false }) shipperModal: ElementRef;
  @ViewChild('invoiceModal', { static: false }) invoiceModal: ElementRef;
  @ViewChild('invoiceEditModal', { static: false }) invoiceEditModal: ElementRef;
  @ViewChild('itemDescriptionInput') itemDescriptionInput!: ElementRef<HTMLInputElement>;
  @ViewChild('itemQtyInput') itemQtyInput!: ElementRef<HTMLInputElement>;
  @ViewChild('itemRateInput') itemRateInput!: ElementRef<HTMLInputElement>;
  @ViewChild('stockIdInput') stockIdInput!: ElementRef<HTMLInputElement>;
  @ViewChild('vendorIdField', { static: false }) vendorIdField: ElementRef;
  @ViewChild('boothId') boothId!: ElementRef<HTMLInputElement>;
  @ViewChild('posVendorSearch') posVendorSearch: any;
  @ViewChild('vendorSearch') vendorSearch: any;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild(PassCodeAuthentication, { static: false }) PassCodeAuthentication: PassCodeAuthentication;
  isVendorPopUp = true;
  trackSalesbyPerson = false;
  applyVenDiscountaboveUd = false;
  applySalesTax = false;
  previousMenu;
  applySecLvlTax = false;
  applySalesTaxOnSecLvlTax = false;
  salesTaxPercent
  secondLevelTaxPercent;
  salesPersonData;
  universalDiscount;
  giftCertificateList = [];
  secondLevelTaxName = "";
  applySalesTaxItemWise = false;
  fillDefaultIteminPos = false;
  allowPossalesWithOutBooking = false;
  enableOtherChargeinPos = false;
  posotherChargeName = "";
  defaultItemName = "";
  vendorName;
  vendorPhone = "";
  boothList;
  stockImageUrl = '';
  showVendorSearch = false
  allowVendorDiscount;
  posTransactionByVendor;
  gcMaxDays = 0;
  rowseqId = 0;
  addNewItem = true;
  updateExistingItem = false;
  isAddingItemToGrid = false;
  existingCustomer = false;
  existingShipper = false;
  allowCommissionOverride = false;
  customerId;
  shipperId
  customerData;
  shipperData;
  vendorSeqId;
  showDropdown = false;
  noDiscountPlan = false;
  activeIndex = -1;
  usStates = [];
  customerSearch = true;
  newCustomer = false;
  shipperSearch = true;
  newShipper = false;
  userList;
  customerSalesForm: FormGroup;
  invoiceForm: FormGroup;
  invoiceEditForm: FormGroup
  voidLayawayForm: FormGroup;
  invoicePayDataForm: FormGroup;
  invoiceChangePaymentForm: FormGroup;
  changeCardTypeForm: FormGroup;
  inputtedCCAmt;
  transactionType = "CREDITSALE";
  invoiceList = [];
  salesType;
  editInvoiceOpen = false;
  flatCommission = 0;
  stockIdOnFocus = ''; // Stock ID value when the field gained focus; used to detect a removed Stock ID
  showCommissiononPos = false;
  pendingSale = false;
  warnon100PercentDiscount = false;
  warnonAnyDiscount = false;
  seqInvoiceNo = 0;
  isScrapReasonVisible = false;
  recentPendingSaleList = [];
  enableBag = false;
  bagVendorSeqId: number = null;
  bagMarketVendorId = '';
  bagVendorName = '';
  bagPrice = 0;
  bagTaxable = false;
  bagBoothNo = '';
  isAddingBag = false;
  downPaymentPercent;
  layawayNumberOfDays;
  numberOfInstalments;
  selectedInvoiceRow;
  layawayMessage;
  defCustIdForRetail;
  custIdReqPendingSale;
  defCustIdForPendingSale;
  salesPageVisible = true;
  showInstallments = false;
  layawayInvoiceDetails;
  paidInstallmentCount = 0;
  hideCheckout = false;
  minDate;
  currentDate;
  gcSaleTerm = "";
  gcVendorId;
  gcBoothNo;
  userSalesToolbar = false;
  useBarcodeScanner = false;
  useNoScannerDefault = false;
  bookingExistForGCVen = false;
  gcMarketVendorId;
  VendorFilterOption: IVendorsFilterOptions;
  allowNegetiveSalesInPos = false;
  vendorBoothIDChange = false;
  travelerCheckTerm = "";
  discountCouponPercent;
  userTerminal = 0;
  defaultTerminalSelection;
  layawayReceiptIds;
  layawayReceiptDropdown: Array<{ SalesRectId: number; ReceiptType: string }> = [];
  selectedLayawayReceiptId: number | null = null;
  saleStatus = "New";
  dispChangePayType = false;
  suppressNextPasscodePrompt = false;
  dayendRowData;
  openCashNotSet = false;
  loading = false;
  printThermalReceipt = false;
  thermalReceiptCopies = 1;
  posMerchantCopy = false;
  posMerchantCopies = 1;
  posCustomerCopy = false;
  posCustomerCopies = 1;
  uniqueSessionId = "";
  dayendOrOpenCashNotSaved = false;
  isInvoiceLoading = false;
  creditCardList;
  chargeCCProcessingFee = false;
  processPayment = false;
  voidPayment = false;
  paymentGatewayCredentials;
  processCreditCardOnline;
  dayendProcessedForToday = false;
  customerEmailAdd;
  public consignmentItems: any[] = [];
  searchField = 6;
  searchValue: string | null = null;
  inventoryType = 'All';
  enableInventory = false;
  antiqueVillageChanges = false;
  inventoryPageNumber = 1;
  inventoryPageSize = 100;
  inventoryHasMore = true;
  isLoadingMoreInventory = false;
  marketDate;
  currentSalesReceiptId: number = 0;
  allowVoid = false;
  userSaleTypePermission;
  currentInvoiceData: any;
  defaultVendorIdChangeReason = '';

  constructor(private router: Router,
    private userService: UserService,
    private formbuilder: FormBuilder,
    private vendorService: VendorService,
    private salesPersonService: SalesPersonService,
    private posSettingsService: PosSettingsService,
    private customCurrency: customCurrencyPipe,
    private menuService: MenuSelectionService,
    private posSalesService: PosSalesService,
    private generalService: GeneralService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private posOpeningCashDrawerService: PosOpeningCashDrawerService,
    private wordReplacePipe: WordReplacePipe,
    private sanitizer: DomSanitizer,
    private printerService: PrinterSettingsService,
    private commonCalculatorService: CommonCalculatorService,
    private creditCardTypeService: CreditCardTypeService,
    private paymentService: PaymentService,
    private dayEndService: DayEndService,
    private consignmentService: ConsignmentService,
    private inventoryService: InventoryService,
    private giftCertificatesService: GiftCertificatesService
  ) {
    this.VendorFilterOption = {
      All: true,
      Current: false,
      Inactive: false,
      PageModel: {
        pageCount: 1,
        pageSize: 20
      }
    }

    this.customerSalesForm = this.formbuilder.group({
      vendorId: [''],
      vendorSeqId: [''],
      boothId: [''],
      stockId: [''],
      itemDescription: [''],
      itemQty: [''],
      itemRate: ['$0.00'],
      itemNoTax: [false],
      itemDiscType: ['2'],
      itemDiscValue: ['0.0000'],
      itemFirm: [false],
      itemCommission: [{ value: '0.00', disabled: true }],
      salesPersonId: ['0'],
      invoiceNo: ['New'],
      scrapReason: [''],
      returnAmount: [{ value: '0.00', disabled: true }],
      returnReason: [''],
      selectedPendingSale: ['0'],
      downPaymentPercent: ['0'],
      downPaymentAmt: ['$0.00'],
      downPaymentMaxDays: [0],
      downPaymentExpiryDate: [new Date()],
      installmentNo: [0],
      paymentBal: ['$0.00'],
      gcStartDate: [new Date()],
      gcMaxDays: [0],
      gcExpiryDate: [new Date()],
      gcNo: [''],
      printReceipt: [false],
      displayReceipt: [false],
      otherCharge: ['$0.00'],
      customerCccharge: ['$0.00'],
      barcodeScanner: [false],
      defaultNoScanner: [false],
      vendorComments: ['']
    })

    this.minDate = new Date();
    this.currentDate = new Date();
    this.customerSalesForm.get('gcStartDate').setValue(this.minDate);
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.invoiceForm = this.formbuilder.group({
      invoiceNumber: [""],
      invoiceFromDate: [today],
      invoiceToDate: [today],
      dateFilter: [true],
      terminalName: ['ALL'],
      invoiceAmount: [''],
      saleType: [0],
      firstName: [''],
      lastName: [''],
      userId: [0]
    })

    this.invoiceEditForm = this.formbuilder.group({
      invoiceNumber: [{ value: '', disabled: true }],
      editCustomerOrStock: ['customer'],
      existingVendorId: [{ value: '', disabled: true }],
      existingBoothId: [{ value: '', disabled: true }],
      existingStockId: [{ value: '', disabled: true }],
      existingQty: [{ value: '', disabled: true }],
      existingRate: [{ value: '', disabled: true }],
      existingItemDescription: [{ value: '', disabled: true }],
      newVendorId: [''],
      newBoothId: [''],
      newComm: ['0.00'],
      newStockId: [{ value: '', disabled: true }],
      newItemDescription: [''],
      changeReason: [''],
      invoiceItemId: [''],
      existingVendorSeqId: [{ value: '', disabled: true }],
      newVendorSeqId: [''],
      ItemSerialNumber: ['']
    })

    this.voidLayawayForm = this.formbuilder.group({
      downPaymentReceived: [{ value: '$0.00', disabled: true }],
      installmentPayReceived: [{ value: '$0.00', disabled: true }],
      LastestinstallmentReceived: [{ value: '$0.00', disabled: true }],
      TotalPaymentReceived: [{ value: '$0.00', disabled: true }],
      LayawayReceipt: [''],
      LayawayReceiptAmount: [{ value: '$0.00', disabled: true }],
      reasonForLayawayVoid: ['']
    })

    this.invoicePayDataForm = this.formbuilder.group({
      invNetPrice: [{ value: '$0.00', disabled: true }],
      invoiceTotAmt: [{ value: '$0.00', disabled: true }],
      invSalesTax: [{ value: '$0.00', disabled: true }],
      invOtherCharge: [{ value: '$0.00', disabled: true }],
      invSecLvlTax: [{ value: '$0.00', disabled: true }],
      invBalanceDue: [{ value: '$0.00', disabled: true }],
      invCashPaid: [{ value: '$0.00', disabled: true }],
      invCheckPaid: [{ value: '$0.00', disabled: true }],
      invCheckNo: [{ value: '', disabled: true }],
      invCCPaid: [{ value: '$0.00', disabled: true }],
      invTravelerCheckPaid: [{ value: '$0.00', disabled: true }],
      invTravelerCheckNo: [{ value: '', disabled: true }],
      invCCCharges: [{ value: '$0.00', disabled: true }],
      invCardType: [{ value: '', disabled: true }]
    })

    this.invoiceChangePaymentForm = this.formbuilder.group({
      invsChngPayCashPaid: [{ value: '$0.00', disabled: true }],
      invsChngPayCheckPaid: [{ value: '$0.00', disabled: true }],
      invsChngPayCheckNo: [{ value: '', disabled: true }],
      invsChngPayCCPaid: [{ value: '$0.00', disabled: true }],
      invsChngPayTravCheckPaid: [{ value: '$0.00', disabled: true }],
      invsChngPayTravCheckNo: [{ value: '', disabled: true }],
      invsChngPayModifiedCash: ['$0.00'],
      invsChngPayModifiedCheck: ['$0.00'],
      invsChngPayModifiedCheckNo: [''],
      invsChngPayModifiedCC: ['$0.00'],
      invsChngPayModifiedTravCheck: ['$0.00'],
      invsChngPayModifiedTravCheckNo: [''],
      invsChngPayModifiedTotalPaid: ['$0.00'],
      invsChngPayModifiedCardType: [{ value: '1', disabled: true }],
    })

    this.changeCardTypeForm = this.formbuilder.group({
      changeCardTypeInvoice: [{ value: '', disabled: true }],
      changeCardTypeCCAmt: [{ value: '$0.00', disabled: true }],
      changeCardTypeCurrentCard: [{ value: '', disabled: true }],
      changeCardTypeNewCard: [{ value: '' }]
    })

    this.customerSalesForm.get('gcNo')?.valueChanges.subscribe(value => {
      if (value == null) return;
      const sanitized = String(value).replace(/[^a-zA-Z0-9]/g, '').slice(0, 16);
      if (String(value) !== sanitized) {
        this.customerSalesForm.get('gcNo')?.setValue(sanitized, { emitEvent: false });
        this.customerSalesForm.get('gcNo')?.markAsTouched();
      }
    });
    this.customerSalesForm.get('gcStartDate')?.valueChanges.subscribe(() => this.syncExpiryFromMaxDays());
    this.customerSalesForm.get('gcMaxDays')?.valueChanges.subscribe(() => this.syncExpiryFromMaxDays());
    this.customerSalesForm.get('gcExpiryDate')?.valueChanges.subscribe(() => this.syncMaxDaysFromExpiry());
    this.customerSalesForm.get('downPaymentExpiryDate')?.valueChanges.subscribe(() => this.onLayawayExpiryDateChange());

    this.customerSalesForm.get('itemQty')?.valueChanges.subscribe(() => {
      const stockId = this.customerSalesForm.get('stockId')?.value;

      if (stockId?.toUpperCase().startsWith('CON')) {
        this.customerSalesForm.get('itemQty')?.setValue(1, { emitEvent: false });
      }
    });

    this.customerSalesForm.get('itemDiscValue')?.valueChanges.subscribe(value => {
      this.validateDiscountValue(value);
    });

    this.customerSalesForm.get('defaultNoScanner')?.valueChanges.subscribe((isChecked: boolean) => {
      const scannerControl = this.customerSalesForm.get('barcodeScanner');

      // a grid item is selected for edit - block the toggle and revert it, same as the desktop app
      if (this.updateExistingItem) {
        this.customerSalesForm.get('defaultNoScanner')?.setValue(!isChecked, { emitEvent: false });
        this.showWarning('Please update or delete the item and proceed');
        return;
      }

      if (isChecked) {
        scannerControl?.disable({ emitEvent: false });
        scannerControl?.setValue(false, { emitEvent: false }); // optional: turn it off
      } else if (this.useBarcodeScanner) {
        scannerControl?.enable({ emitEvent: false });
        scannerControl?.setValue(true, { emitEvent: false });
      }
    });

    this.customerSalesForm.get('barcodeScanner')?.valueChanges.subscribe((res: boolean) => {
      this.setFocusToFirstField();
    });
    this.customerSalesForm.get('defaultNoScanner')?.valueChanges.subscribe((res: boolean) => {
      this.setFocusToFirstField();
    });

    this.invoiceForm.get('dateFilter')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((enabled: boolean) => {
      this.setInvoiceDateFilterState(enabled);
    });
    this.setInvoiceDateFilterState(this.invoiceForm.get('dateFilter')?.value === true);
  }
  isCollapsed: boolean = true;

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  getMarketCurrentTime(): void {
    this.generalService.GetMarketCurrentTime()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.marketDate = this.datePipe.transform(res, 'yyyy-MM-dd');
          this.invoiceForm.patchValue({
            invoiceFromDate: this.marketDate,
            invoiceToDate: this.marketDate
          });
          this.loadInvoiceList();
        },
        error: (err) => {
        }
      });
  }

  formatDate(dateValue: string | Date): string {
    return this.datePipe.transform(dateValue, 'd MMMM y'); // Example: 20 October 2025
  }

  private setInvoiceDateFilterState(enabled: boolean): void {
    const fromDateControl = this.invoiceForm.get('invoiceFromDate');
    const toDateControl = this.invoiceForm.get('invoiceToDate');

    if (enabled) {
      fromDateControl?.enable({ emitEvent: false });
      toDateControl?.enable({ emitEvent: false });
    } else {
      fromDateControl?.disable({ emitEvent: false });
      toDateControl?.disable({ emitEvent: false });
    }
  }

  checkItemPrice() {
    const rateEntered = this.getActualAmountFromInp(this.customerSalesForm.get('itemRate').value) > 0;
    const isFirm = this.customerSalesForm.get('itemFirm')?.value;
    (rateEntered && !isFirm) ? this.customerSalesForm.get('itemDiscValue').enable() : this.customerSalesForm.get('itemDiscValue').disable();
  }

  onFirmChange() {
    if (this.isFirmItem()) {
      this.customerSalesForm.patchValue({ itemDiscType: '2', itemDiscValue: '0.0000' });
      this.showDropdown = false;
      this.activeIndex = -1;
    }
    this.checkItemPrice();
  }

  // Firm items are sold without discount - vendor plan / inventory discounts must not be auto-applied
  private isFirmItem(): boolean {
    return !!this.customerSalesForm.get('itemFirm')?.value;
  }

  private validateDiscountValue(value: any): void {
    const discType = this.customerSalesForm.get('itemDiscType')?.value;
    const qty = this.customerSalesForm.get('itemQty')?.value;
    const itemRate = this.getActualAmountFromInp(this.customerSalesForm.get('itemRate')?.value);
    var totalItemPrice = itemRate * qty;
    // discType 1 = Flat Amount — cannot exceed item rate
    if (discType == '1' && value > totalItemPrice) {
      this.customerSalesForm.get('itemDiscValue')?.setValue(totalItemPrice, { emitEvent: false });
    }
    // discType 2 = Percentage — cannot exceed 100%
    if (discType == '2' && value > 100) {
      this.customerSalesForm.get('itemDiscValue')?.setValue(100, { emitEvent: false });
    }
  }

  ngOnInit(): void {
    this.checkDayEndProcessForLoggedInUser()
    this.checkOpenCashSavedForTrans();
    const tabId = sessionStorage.getItem('tabId');
    const sessionKey = `UniqueSessionId-${tabId}`;
    this.uniqueSessionId = localStorage.getItem(sessionKey);
    this.generalService.getTerminal().subscribe(value => {
      this.userTerminal = value; // 
    });

    this.menuService.selectedMenu$
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(menu => this.handleMenuChange(menu));

    this.getMarketCurrentTime();
    this.getSalesPerson();
    this.getTerminals();
    this.getPosAndUserSettings();
    this.getPOSSalesType();
    this.getActiveUniversalDiscount();
    this.getUserList();
    this.getSalesTaxAndCommissionSettings();
    this.getGiftCertificates();
    this.getASCloudLicenseSettings();
    this.getCustomMarketSettings();
    this.CancelTransactionOnRefreshOrReload();
  }

  getCustomMarketSettings() {
    this.generalService.getCustomMarketSettings()
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.antiqueVillageChanges = res?.AntiqueVillageChanges ?? false;
        },
        error: (err) => {
          console.error('Failed to load custom market settings:', err);
        }
      });
  }

  checkDayEndProcessForLoggedInUser() {
    this.dayEndService.checkDayEndProcessForLoggedInUser().subscribe(async (res) => {
      if (res !== null && res.Status) {
        const result = await Swal.fire({
          title: $localize`Confirm`,
          text: $localize`Day end process is already completed for today! Do you want to lookup invoices?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: $localize`Yes`,
          cancelButtonText: $localize`No`
        });

        if (result.isConfirmed) {
          this.dayendProcessedForToday = true;
        } else {
          this.router.navigate(['/dashboard']);
        }
      }
    })
  }

  getConsignmentProductForPOS() {

    const searchField = !this.searchValue ? 0 : this.searchField;
    const searchValue = !this.searchValue ? null : this.searchValue;

    this.inventoryPageNumber = 1;
    this.inventoryHasMore = true;

    // Only Consignment
    if (this.inventoryType === 'Consignment') {
      this.consignmentService
        .getConsignmentProductForPOS(searchField, searchValue)
        .subscribe(res => {
          this.consignmentItems = this.mapConsignment(res);
        });
    }

    // Only Inventory
    else if (this.inventoryType === 'Inventory') {
      this.isLoadingMoreInventory = true;
      this.inventoryService
        .getInventoryStockForPOS(searchField, searchValue, this.inventoryPageNumber, this.inventoryPageSize)
        .subscribe({
          next: res => {
            const inventoryData = this.mapInventory(res);
            this.consignmentItems = inventoryData;
            this.inventoryHasMore = inventoryData.length === this.inventoryPageSize;
            this.isLoadingMoreInventory = false;
          },
          error: () => {
            this.isLoadingMoreInventory = false;
          }
        });
    }

    else if (this.inventoryType === 'All') {

      this.isLoadingMoreInventory = true;
      forkJoin({
        consignment: this.consignmentService.getConsignmentProductForPOS(searchField, searchValue),
        inventory: this.inventoryService.getInventoryStockForPOS(searchField, searchValue, this.inventoryPageNumber, this.inventoryPageSize)
      }).subscribe({
        next: ({ consignment, inventory }) => {
          const consignmentData = this.mapConsignment(consignment);
          const inventoryData = this.mapInventory(inventory);

          // ✅ Combine both
          this.consignmentItems = [...consignmentData, ...inventoryData];
          this.inventoryHasMore = inventoryData.length === this.inventoryPageSize;
          this.isLoadingMoreInventory = false;
        },
        error: () => {
          this.isLoadingMoreInventory = false;
        }
      });
    }
  }

  // Loads the next page of inventory rows and appends them; called when the modal's list is scrolled to the bottom.
  loadMoreInventory(): void {
    if (this.isLoadingMoreInventory || !this.inventoryHasMore) return;
    if (this.inventoryType !== 'Inventory' && this.inventoryType !== 'All') return;

    const searchField = !this.searchValue ? 0 : this.searchField;
    const searchValue = !this.searchValue ? null : this.searchValue;
    const nextPage = this.inventoryPageNumber + 1;

    this.isLoadingMoreInventory = true;
    this.inventoryService
      .getInventoryStockForPOS(searchField, searchValue, nextPage, this.inventoryPageSize)
      .subscribe({
        next: res => {
          const inventoryData = this.mapInventory(res);
          this.consignmentItems = [...this.consignmentItems, ...inventoryData];
          this.inventoryPageNumber = nextPage;
          this.inventoryHasMore = inventoryData.length === this.inventoryPageSize;
          this.isLoadingMoreInventory = false;
        },
        error: () => {
          this.isLoadingMoreInventory = false;
        }
      });
  }

  onInventoryScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const hasOverflow = el.scrollHeight > el.clientHeight;
    const reachedBottom = hasOverflow && (el.scrollTop + el.clientHeight >= el.scrollHeight - 50);
    if (reachedBottom) {
      this.loadMoreInventory();
    }
  }

  private mapConsignment(res: any[]) {
    if (!res) return [];

    return res.map(el => ({
      StockId: el.StockId,
      ProductName: el.ProductName,
      ProductDesc: el.ProductDesc,
      VendorId: el.VendorId,
      VendorName: el.VendorName,
      VendorAlphaId: el.VendorAlphaId,
      ConsignSpaceId: el.ConsignSpaceId,
      Price: el.Price,
      CommissionPercent: el.CommisionPercent,
      CommissionAmount: el.CommisionAmount,
      StockImageUrl: ""
    }));
  }

  private mapInventory(res: any[]) {
    if (!res) return [];

    return res.map(el => ({
      StockId: el.StockId,
      ProductName: el.ItemDescription,
      ProductDesc: el.ItemDescription,
      VendorId: el.VendorId,
      VendorName: el.VendorName,
      VendorAlphaId: el.VenAlphaNumId,
      ConsignSpaceId: '',
      Price: el.Rate,
      CommissionPercent: el.CommissionRate,
      StockCount: el.CurrentStock,
      NoTax: el?.NoTax,
      VendorDiscount: el?.VendorDiscount,
      StockImageUrl: el?.InventoryImageUrl ? `${el.InventoryImageUrl}?t=${Date.now()}` : ""
    }));
  }

  closeConsignmentModel(resetFilters: boolean = true) {
    if (resetFilters) {
      this.inventoryType = "All";
      this.searchValue = "";
      this.searchField = 6;
    }
    this.closeModalById('consignmentInventory');
  }

  getConsignmentItemData(data) {
    if (data) {
      this.customerSalesForm.patchValue({
        stockId: data.StockId,
        itemRate: this.customCurrency.transform(data.Price),
        itemQty: 1,
        vendorId: data.VendorAlphaId,
        vendorSeqId: data.VendorId,
        itemDescription: data.ProductName,
        itemCommission: data.CommissionPercent,
        itemNoTax: data?.NoTax ?? false,
        itemDiscType: '2',
        itemDiscValue: this.isFirmItem() ? '0.0000' : data.VendorDiscount
      });
      this.inventoryItemDiscount = data.VendorDiscount ?? null;
      this.stockImageUrl = data.StockImageUrl || '';
      // Only override inventory discount when DiscountAll is active; plan list discounts should not override it
      if (this.discountAllPercent != null) {
        this.applyBestDiscount();
      }

      this.closeConsignmentModel(false);
    }
  }

  ngAfterViewInit(): void {
    this.getAllCreditCardsByMarket();
    this.getCreditCardFeeSettings();
    this.getCCCredentials();
  }

  getCCCredentials() {
    this.paymentService.getCCCredentials().subscribe((res) => {
      if (res !== null) {
        this.paymentGatewayCredentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.processCreditCardOnline = res.ProcessCreditCardOnline;
      }
    })
  }

  CancelTransactionOnRefreshOrReload() {
    let obj = localStorage.getItem("StripeCancelPaymentReq");
    const jsObject = JSON.parse(obj);
    this.paymentService.CancelTransactionOnRefreshOrReload(jsObject).subscribe((res) => {
      if (res !== null) {
        localStorage.removeItem("StripeCancelPaymentReq");
      }
    })
  }

  getCreditCardFeeSettings() {
    this.creditCardTypeService.getCreditCardFeeSettings()
      .pipe(take(1)).subscribe(res => {
        if (res) {
          this.chargeCCProcessingFee = res.ChargeCCProcessingFee;
        }
      })
  }

  handleMenuChange(menu) {
    this.currentMenu = menu;
    if (this.previousMenu == "gc" && !this.invoiceNo && this.customerItemList.length > 0) {
      if (this.currentMenu == '6') {
        this.showWarning(`Pending sale cannot be performed to gift certificate!.`);
      } else {
        this.showWarning(`Cancel the current transaction before proceeding.`);
      }
      this.previousMenu = "";
      setTimeout(() => {
        this.menuService.setMenu('gc')
      }, 0);
      return;
    }

    if (this.previousMenu == "gc" && this.currentMenu != "gc") {
      this.customerSalesForm.get('vendorId')?.setValue('');
    }

    if (this.currentMenu == "gc" && this.previousMenu && this.previousMenu != "gc" && !this.invoiceNo && this.customerItemList.length > 0) {
      this.showWarning(`Cancel the current transaction before proceeding.`);
      const revertMenu = this.previousMenu;
      this.previousMenu = "";
      setTimeout(() => {
        this.menuService.setMenu(revertMenu)
      }, 0);
      return;
    }

    if (this.seqInvoiceNo && ((this.previousMenu == '8' && this.currentMenu == '7') || (this.previousMenu == '7' && this.currentMenu == '8'))) {
      const gridSaleType = this.customerItemList[0] ? this.customerItemList[0]?.SaleType.toString() : '0';
      Swal.fire({
        text: $localize`Invalid Sale Type Selection.`,
        icon: 'warning',
        confirmButtonText: $localize`Ok`,
        didClose: () => {
          this.suppressNextPasscodePrompt = gridSaleType === '7' || gridSaleType === '8';
          this.menuService.setMenu(gridSaleType);
        }
      });
      return;
    };

    this.previousMenu = menu;
    this.resetItemTaxCheckBox();
    this.customerSalesForm.patchValue({
      returnReason: this.savedReturnReason,
      scrapReason: "",
      returnAmount: this.customCurrency.transform("0")
    });
    this.checkItemOnGrid();
  }

  checkOpenCashSavedForTrans() {
    this.posOpeningCashDrawerService.checkOpenCashSavedForTransaction()
      .pipe(take(1))
      .subscribe({
        next: (response: IOpenCashModel) => {
          this.loaderIcon = Promise.resolve(false);
          var posOpenCashDetails = response;
          if (posOpenCashDetails && posOpenCashDetails.PreviousEODNotProcessedDate) {
            const dateEODNotProcessed = posOpenCashDetails.PreviousEODNotProcessedDate.substring(5, 7) + '/' + posOpenCashDetails.PreviousEODNotProcessedDate.substring(8, 10) + '/' + posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 4);
            posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 10)
            Swal.fire({
              text: $localize`:@@MsgDayendForDateNotSubmitted:The Day end for date: ${dateEODNotProcessed} is not submitted!`,
              icon: 'warning',
              confirmButtonText: $localize`:@@Ok:Ok`,
              didClose: async () => {
                const result = await Swal.fire({
                  title: $localize`Confirm`,
                  text: $localize`Are you sure you want to process dayend for ${dateEODNotProcessed}`,
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonText: $localize`Yes`,
                  cancelButtonText: $localize`No`
                });

                if (result.isConfirmed) {
                  const userData = await lastValueFrom(
                    this.generalService.getLoggedInUserAndTerminal().pipe(take(1))
                  );
                  this.dayendRowData = {
                    UserId: userData.UserId,
                    Terminal: userData.TerminalName,
                    OpeningCashDate: this.datePipe.transform(posOpenCashDetails.PreviousEODNotProcessedDate, "yyyy-MM-dd")
                  }
                  this.generalService.setDayendRowDataForTrans(this.dayendRowData);
                  var url = 'ops/pos/day-end-process/trans';
                  this.router.navigate([url]);
                } else {
                  this.dayendOrOpenCashNotSaved = true;
                }
              }
            });
          }
          else if (!posOpenCashDetails || posOpenCashDetails.Id == 0) {
            this.hideOpenCashTopMenu = true;
            this.openCashNotSet = true
            this.openModalById('modalOpenCash')
          }
        }
      })
  }

  openCashSaved(val) {
    this.closeModalById('modalOpenCash');
  }

  btnCloseOpenCash() {
    this.dayendOrOpenCashNotSaved = true;
    this.closeModalById('modalOpenCash');
  }

  getTerminals() {
    this.loaderIcon = Promise.resolve(true);
    this.posOpeningCashDrawerService.getPOSTerminals()
      .pipe(take(1))
      .subscribe(res => {
        this.defaultTerminalSelection = [
          ...res.map(el => ({ Id: el.Id, Name: el.Name, Select: false }))
        ];
        this.loaderIcon = Promise.resolve(false);
      })
    this.loaderIcon = Promise.resolve(false);
  }

  toggleSchedule() {
    this.showInstallments = !this.showInstallments;
  }

  async checkItemOnGrid(): Promise<boolean> {
    this.itemVoidorRetn = false;
    if (this.currentMenu == 'gc') {
      this.customerSalesForm.get('itemCommission').setValue(0);
    } else if (this.customerSalesForm.get('itemCommission').value == 0 && this.flatCommission > 0) {
      this.customerSalesForm.get('itemCommission').setValue(this.flatCommission);
    }
    if (this.customerItemList.length === 0 || !this.invoiceNo) {
      if (this.currentMenu == '7' || this.currentMenu == '8') {
        const msg = this.currentMenu === '7'
          ? $localize`Please load invoice first and then click on Return option..!`
          : $localize`Please load invoice first and then click on Void option..!`;

        Swal.fire({
          text: msg,
          icon: 'warning',
          confirmButtonText: $localize`Ok`,
          didClose: () => {
            this.menuService.setMenu('1');
          }
        });
      }
      return true;
    }

    const gridSaleType = this.customerItemList[0] ? this.customerItemList[0]?.SaleType.toString() : '0';

    const gridInvoiceDate = this.customerItemList[0]?.InvoiceDate ?? new Date();

    if (gridSaleType === '0') {
      return true;
    }

    if (this.currentMenu == '8' && gridSaleType != '6') {
      const invoiceDate = new Date(gridInvoiceDate).setHours(0, 0, 0, 0);
      var currentDate = await lastValueFrom(this.generalService.GetMarketCurrentTime());
      const today = new Date(currentDate).setHours(0, 0, 0, 0);

      if (invoiceDate < today && gridSaleType != '8') {
        const msg = $localize`Previous date sale cannot be voided!`;

        await Swal.fire({
          text: msg,
          icon: 'warning',
          confirmButtonText: $localize`Ok`
        });

        this.menuService.setMenu(gridSaleType.toString());
        this.customerItemList = [];
        this.loadedOrgItemList = [];
        this.resetInvoiceNo();
        this.editInvoiceOpen = false;
        this.customerData = "";
        this.customerId = 0;
        return false;
      }
    }

    const saleTypeGroup1 = ['1', '2', '3', '5'];
    const saleTypeGroup2 = ['8'];
    const saleTypeGroup3 = ['7'];

    const showInvalidSelectionAlert = () => {
      Swal.fire({
        text: $localize`Invalid Sale Type Selection.`,
        icon: 'warning',
        confirmButtonText: $localize`Ok`,
        didClose: () => {
          this.suppressNextPasscodePrompt = gridSaleType === '7' || gridSaleType === '8';
          this.menuService.setMenu(gridSaleType);
        }
      });
    };

    if (saleTypeGroup1.includes(gridSaleType)) {
      if (this.currentMenu !== '7' && this.currentMenu !== '8') {
        if (this.seqInvoiceNo && gridSaleType === this.currentMenu) {
          this.previousMenu = this.currentMenu;
          return true;
        } else {
          showInvalidSelectionAlert();
          return false;
        }
      }
      this.previousMenu = this.currentMenu;
    }

    if (saleTypeGroup2.includes(gridSaleType)) {
      if (this.currentMenu !== '8') {
        showInvalidSelectionAlert();
        return false;
      }
    }

    if (saleTypeGroup3.includes(gridSaleType)) {
      if (this.currentMenu !== '7') {
        showInvalidSelectionAlert();
        return false;
      }
    }

    if (['5', '6'].includes(gridSaleType.toString())) {
      if (['7', '8'].includes(this.currentMenu)) {
        const typeLabel = gridSaleType === '6' ? $localize`Pending sale` : $localize`Layaway`;
        const actionLabel = this.currentMenu === '7' ? $localize`returned` : $localize`voided`;

        Swal.fire({
          text: `${typeLabel} cannot be ${actionLabel}.`,
          icon: 'warning',
          confirmButtonText: $localize`Ok`,
          didClose: () => {
            this.menuService.setMenu(gridSaleType.toString());
          }
        });

        return false;
      }
    }

    if (this.currentMenu === '8' && gridSaleType != '8') {
      var totalReturnAmount = this.getActualAmountFromInp(this.getTotalInvoiceAmount()) + this.getActualAmountFromInp(this.customerSalesForm.get('otherCharge').value ?? 0)
        + this.getActualAmountFromInp(this.customerSalesForm.get('customerCccharge').value ?? 0);
      const fmttotalReturnAmount = this.fmt(totalReturnAmount.toString());
      this.customerSalesForm.get('returnAmount').setValue(fmttotalReturnAmount);
    }

    if (this.currentMenu == '7' || this.currentMenu == '8') {
      if (this.suppressNextPasscodePrompt) {
        this.suppressNextPasscodePrompt = false;
      } else {
        this.selectedOptionBeforePasscodeAuth = this.currentMenu;
        this.PassCodeAuthentication.OpenModal();
      }
    }

    if (gridSaleType == '7' || gridSaleType == '8') {
      this.itemVoidorRetn = true;
    }

    return true;  // All other cases: allow menu change
  }

  onLayawayExpiryDateChange() {
    const expiry = this.customerSalesForm.get('downPaymentExpiryDate')?.value;
    if (!expiry) { return; }

    const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const today = startOfDay(new Date());               // normalize 'today' to 00:00
    const expiryDay = startOfDay(new Date(expiry));     // normalize expiry to 00:00

    const msPerDay = 1000 * 60 * 60 * 24;
    const diffDays = Math.round((+expiryDay - +today) / msPerDay); // integer diff

    const maxDays = diffDays > 0 ? diffDays : 0;        // clamp negative to 0

    this.customerSalesForm.get('downPaymentMaxDays')?.setValue(maxDays);
    this.calculateLayaway();
  }

  private calcDownpayPercBasedonAmt() {
    const downPaymentAmount = this.getActualAmountFromInp(this.customerSalesForm.get('downPaymentAmt')?.value || 0);

    const netPrice = this.customerItemList.reduce((total, item) => {
      const discountedPrice = item.ItemDiscountedPrice
        ? this.getActualAmountFromInp(item.ItemDiscountedPrice)
        : 0;

      const salesTax = item.ItemSalesTax
        ? this.getActualAmountFromInp(item.ItemSalesTax)
        : 0;

      const secLvlTax = item.ItemSecLvlTax
        ? this.getActualAmountFromInp(item.ItemSecLvlTax)
        : 0;

      return total + discountedPrice + salesTax + secLvlTax;
    }, 0);

    var otherCharge = this.getActualAmountFromInp(this.customerSalesForm.get('otherCharge')?.value) || 0;
    const roundedNetPrice = +netPrice.toFixed(4) + otherCharge;
    var downPaymentPercent = this.roundToTwo((downPaymentAmount / roundedNetPrice) * 100);
    if (downPaymentPercent > 100) {
      this.showWarning('Down payment cannot exceed the total amount. Setting to 100%.');
      // Set amount to 100% (total price)
      const maxDownPaymentAmt = roundedNetPrice;
      this.customerSalesForm.get('downPaymentAmount')?.setValue(this.roundToTwo(maxDownPaymentAmt), { emitEvent: false });
      downPaymentPercent = 100;
    }
    this.customerSalesForm.get('downPaymentPercent')?.setValue(downPaymentPercent, { emitEvent: false });
    this.calculateLayaway();
  }

  private calculateLayaway() {
    const downPercent = +this.customerSalesForm.get('downPaymentPercent')?.value || 0;
    const maxDays = +this.customerSalesForm.get('downPaymentMaxDays')?.value || 0;
    const installments = +this.customerSalesForm.get('installmentNo')?.value || 1;

    const netPrice = this.customerItemList.reduce((total, item) => {
      const discountedPrice = item.ItemDiscountedPrice
        ? this.getActualAmountFromInp(item.ItemDiscountedPrice)
        : 0;

      const salesTax = item.ItemSalesTax
        ? this.getActualAmountFromInp(item.ItemSalesTax)
        : 0;

      const secLvlTax = item.ItemSecLvlTax
        ? this.getActualAmountFromInp(item.ItemSecLvlTax)
        : 0;

      return total + discountedPrice + salesTax + secLvlTax;
    }, 0);

    var otherCharge = this.getActualAmountFromInp(this.customerSalesForm.get('otherCharge')?.value) || 0;

    var customerCCCharge = 0;
    if (this.invoiceNo) {
      var layawayReceiptDetails = this.layawayInvoiceDetails?.LayawayAmountPaidDetails;
      if (layawayReceiptDetails) {
        var downpaymentData = layawayReceiptDetails.find(e => e.ReceiptType == "LAYDNPAYT")
        if (downpaymentData) {
          customerCCCharge = downpaymentData.CustomerCCCharge;
        }
      }
    }

    const roundedNetPrice = +netPrice.toFixed(4) + otherCharge;

    // Down Payment Amount
    var downPaymentAmt = this.roundToTwo((roundedNetPrice * downPercent) / 100);

    // Balance
    const balance = roundedNetPrice - downPaymentAmt;

    let expiryDate = null;
    if (maxDays > 0) {
      const today = !this.invoiceNo || this.pendingSale ? new Date() : new Date(this.layawayInvoiceDetails?.InvoiceDate);
      expiryDate = new Date(today.setDate(today.getDate() + maxDays));
    }

    expiryDate = expiryDate ? expiryDate : null;
    // Patch back into form
    var finaldownPaymentAmt = downPaymentAmt + customerCCCharge;
    this.customerSalesForm.patchValue(
      {
        downPaymentAmt: this.customCurrency.transform(finaldownPaymentAmt.toFixed(4)),
        paymentBal: this.customCurrency.transform(balance.toFixed(4))
      },
      { emitEvent: false } // prevent recursive calls
    );

    this.customerSalesForm.get('downPaymentExpiryDate')?.setValue(expiryDate, { emitEvent: false });

    this.calculateInstallments(roundedNetPrice, downPaymentAmt, maxDays, installments);
  }

  roundToTwo(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  installments: { date: string; amount: number }[] = [];

  calculateInstallments(totalAmount: number, downPayment: number, maxDays: number, installmentNo: number) {
    this.installments = [];

    if (!installmentNo || installmentNo <= 0 || !maxDays) return;

    const remainingAmount = totalAmount - downPayment;
    if (remainingAmount <= 0) return;

    const today = new Date();
    const baseAmount = +(remainingAmount / installmentNo).toFixed(2);

    let totalAssigned = 0;

    // maxDays is inclusive of today (today = day 1), so the last installment
    // must land maxDays - 1 days out to stay within the configured window.
    const effectiveSpan = maxDays - 1;

    for (let i = 0; i < installmentNo; i++) {
      const dayOffset = Math.round(((i + 1) * effectiveSpan) / installmentNo);
      const installmentDate = new Date(today);
      installmentDate.setDate(today.getDate() + dayOffset);

      // adjust rounding for the last installment
      let amount = baseAmount;
      if (i === installmentNo - 1) {
        amount = +(remainingAmount - totalAssigned).toFixed(2);
      }
      totalAssigned += amount;

      this.installments.push({
        date: this.datePipe.transform(installmentDate, 'MM/dd/yyyy'), // YYYY-MM-DD
        amount
      });
    }
  }

  private syncExpiryFromMaxDays(): void {
    const startDateControl = this.customerSalesForm.get('gcStartDate');
    const maxDaysControl = this.customerSalesForm.get('gcMaxDays');
    const expiryDateControl = this.customerSalesForm.get('gcExpiryDate');

    if (!startDateControl || !maxDaysControl || !expiryDateControl) return;

    const startDateValue = startDateControl.value;
    const maxDays = Number(maxDaysControl.value);

    if (!startDateValue || isNaN(maxDays) || maxDays <= 0) return;

    const startDate = new Date(startDateValue);
    startDate.setHours(0, 0, 0, 0);

    // 🔹 expiry = start + (maxDays - 1)
    const expiry = new Date(startDate);
    expiry.setDate(startDate.getDate() + (maxDays));
    expiry.setHours(0, 0, 0, 0);

    expiryDateControl.setValue(expiry, { emitEvent: false });
  }

  private syncMaxDaysFromExpiry(): void {
    const startDateControl = this.customerSalesForm.get('gcStartDate');
    const expiryDateControl = this.customerSalesForm.get('gcExpiryDate');
    const maxDaysControl = this.customerSalesForm.get('gcMaxDays');

    if (!startDateControl || !expiryDateControl) return;

    const startDate = new Date(startDateControl.value);
    let expiryDate = new Date(expiryDateControl.value);

    // Normalize both dates to midnight (ignore time)
    startDate.setHours(0, 0, 0, 0);
    expiryDate.setHours(0, 0, 0, 0);

    if (isNaN(startDate.getTime()) || isNaN(expiryDate.getTime())) return;

    const allowedMaxDays: number = this.gcMaxDays || 365;

    // Calculate max allowed expiry date from start date
    const maxAllowedExpiryDate = new Date(startDate);
    maxAllowedExpiryDate.setDate(maxAllowedExpiryDate.getDate() + allowedMaxDays);
    maxAllowedExpiryDate.setHours(0, 0, 0, 0);

    if (expiryDate > maxAllowedExpiryDate) {
      expiryDate = maxAllowedExpiryDate;

      // Update the expiry date control with capped value
      expiryDateControl.setValue(expiryDate, { emitEvent: false });
      this.toastr.warning($localize`Expiry date cannot exceed ${allowedMaxDays} days from start date. Defaulting to ${maxAllowedExpiryDate.toLocaleDateString()}.`, $localize`Invalid Expiry Date`, this.sharedHTMLSettings.ToasterConfig);
    }

    let maxDays = 0;

    if (expiryDate >= startDate) {
      // Difference in days + 1 (inclusive range)
      const diffInMs = expiryDate.getTime() - startDate.getTime();
      maxDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    } else {
      // expiry < start → reset expiry to start date
      maxDays = 1;
      expiryDateControl.setValue(startDate, { emitEvent: false });

      this.toastr.warning($localize`Expiry date cannot be before start date.`, $localize`Invalid Expiry Date`, this.sharedHTMLSettings.ToasterConfig);
    }

    maxDaysControl?.setValue(maxDays, { emitEvent: false });
  }

  updateExpiryDate(): void {
    const startDateControl = this.customerSalesForm.get('gcStartDate');
    const maxDaysControl = this.customerSalesForm.get('gcMaxDays');
    const expiryDateControl = this.customerSalesForm.get('gcExpiryDate');

    if (!startDateControl || !maxDaysControl || !expiryDateControl) return;

    const startDateValue = startDateControl.value;
    const maxDays = Number(maxDaysControl.value);

    if (!startDateValue) {
      expiryDateControl.reset();
      return;
    }

    const startDate = new Date(startDateValue);
    startDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (startDate < today) {
      startDateControl.setValue(this.minDate);
      return;
    }

    // 🟢 Calculate expiry date
    if (!isNaN(maxDays) && maxDays > 0) {
      // Subtract 1 so day 1 = start date itself
      const expiry = new Date(startDate);
      expiry.setDate(startDate.getDate() + maxDays);
      expiry.setHours(0, 0, 0, 0);

      expiryDateControl.setValue(expiry);
    } else {
      expiryDateControl.reset();
    }
  }

  resetItemTaxCheckBox() {
    if (this.currentMenu == "2" || this.currentMenu == "gc") {
      this.customerSalesForm.get('itemNoTax').setValue(true);
      this.customerSalesForm.get('itemNoTax').disable();
    }
    // else if (this.currentMenu == "5") {
    //   this.customerSalesForm.get('itemNoTax').setValue(false);
    //   this.customerSalesForm.get('itemNoTax').disable();
    // }
    else {
      this.customerSalesForm.get('itemNoTax').setValue(false);
      this.customerSalesForm.get('itemNoTax').enable();
    }

    if (this.currentMenu != '8' && this.currentMenu != '7') {
      this.updateTaxesForAllItems();
    }
  }

  onAmountFormat(val) {
    var inputVal = this.getActualAmountFromInp(this.customerSalesForm.get(val).value).toString();
    if (this.currentMenu != 'gc') {
      if (val == "itemRate") {
        this.applyBestDiscount();
      }
    }
    if (inputVal)
      this.customerSalesForm.get(val).setValue(this.customCurrency.transform(inputVal));

    //this.validateDiscountValue(this.customerSalesForm.get('itemDiscValue')?.value);
  }

  updateTaxesForAllItems() {
    this.customerItemList = this.customerItemList.map(item => {
      const gridSaleType = item?.SaleType ? item?.SaleType.toString() : '0';
      const discountedPrice = item.ItemDiscountedPrice
        ? this.getActualAmountFromInp(item.ItemDiscountedPrice)
        : 0;

      var taxNotApplied = true;
      var itemNoTax = item.ItemNoTax
      let salesTax = 0, secLvlTax = 0;
      var donotApplyTax = this.pendingSale && this.currentMenu == '2' ? true : false;

      var itemList = item.InvoiceItemId
        ? this.loadedOrgItemList.find(x => x.InvoiceItemId == item.InvoiceItemId) ?? null
        : null;

      if (this.pendingSale && this.currentMenu != '2' && itemList != null) {
        item.ItemSalesTax = itemList.ItemSalesTax;
        item.ItemSecLvlTax = itemList.ItemSecLvlTax;
      }

      if (!this.pendingSale && this.seqInvoiceNo && this.seqInvoiceNo !== 0 && !donotApplyTax && itemList) { // existing invoice
        if (this.applySalesTax) {
          const taxValue = this.getActualAmountFromInp(item.ItemSalesTax || 0);
          salesTax = Number(taxValue) || 0;
        }
        if (this.applySecLvlTax) {
          const secTaxValue = this.getActualAmountFromInp(item.ItemSecLvlTax || 0);
          secLvlTax = Number(secTaxValue) || 0;
        }
      }
      else if (this.currentMenu != '2' && !itemNoTax) { // new invoice or pending sale (except pending sale with menu 2)
        if (this.applySalesTax) salesTax = +(discountedPrice * (this.salesTaxPercent / 100)).toFixed(4);
        if (this.applySecLvlTax) secLvlTax = +(discountedPrice * (this.secondLevelTaxPercent / 100)).toFixed(4);
      }

      if (salesTax > 0 || secLvlTax > 0) {
        taxNotApplied = false;
      }

      var netPrice = 0;
      if (this.applySalesTaxItemWise) {
        var netPrice = +(discountedPrice + salesTax + secLvlTax).toFixed(4);
      } else {
        var netPrice = +(discountedPrice).toFixed(4);
      }

      return {
        ...item,
        TaxNotApplied: taxNotApplied,
        ItemSalesTax: this.customCurrency.transform(salesTax.toString()),
        ItemSecLvlTax: this.customCurrency.transform(secLvlTax.toString()),
        ItemNetprice: this.customCurrency.transform(netPrice.toString())
      };
    });
    if (this.currentMenu == '5') {
      this.calculateLayaway();
    }
  }

  getUserList() {
    this.userService.getUserList()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.userList = res;
        }
      });
  }

  onEnterStockId() {
    const value = this.customerSalesForm.get('stockId')?.value;

    if (value && value.trim() !== '') {
      this.validateStockId();
    }
  }

  getPOSVendorActiveDiscountPlan(barcodeScanner, existingRowUpdate = false) {
    this.vendorDiscountText = "";
    this.posSalesService.getPOSVendorActiveDiscountPlan(this.vendorSeqId)
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          if (res.DiscountAll && res.DiscountAllPercent != null) {
            this.discountAllPercent = res.DiscountAllPercent;
            this.vendorDiscountText = `${res.DiscountAllPercent}% Discount on all items`;
            if (!existingRowUpdate && !this.isFirmItem()) {
              this.customerSalesForm.patchValue({
                itemDiscType: '2',
                itemDiscValue: res.DiscountAllPercent
              }, { emitEvent: false });
            }
            this.showDropdown = false;
            return;
          }
        }
        this.discountAllPercent = null;

        if (!barcodeScanner) {
          this.vendorDiscountList = res?.POSDiscountPlans ?? [];
          this.noDiscountPlan = !this.vendorDiscountList?.length;

          if (!this.vendorDiscountList?.length) {
            this.showDropdown = false;
          } else {
            this.showDropdown = true;
            this.vendorDiscountText = this.vendorDiscountList
              .map(d => `${d.DiscountPercent}% ${d.PlanName}`)
              .join('\n');
          }

          const maxDiscount = this.vendorDiscountList?.length
            ? Math.max(
              ...this.vendorDiscountList.map(d => {
                const val = Number(d?.DiscountPercent);
                return isNaN(val) ? 0 : val;
              })
            )
            : 0;

          // Only apply plan list max discount if no inventory discount is already set
          const existingDisc = parseFloat((this.customerSalesForm.get('itemDiscValue')?.value || '0').toString()) || 0;
          if (existingDisc === 0 && !this.isFirmItem()) {
            this.customerSalesForm.get('itemDiscValue')?.setValue(maxDiscount);
          }
        }
      });
  }

  selectAll(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  applyBestDiscount() {
    if (this.isFirmItem()) {
      return;
    }
    // If vendor has a flat "discount all" plan, apply it — unless universal discount is higher
    if (this.discountAllPercent != null) {
      const universal = this.universalDiscount;
      const itemRateRaw = this.customerSalesForm.get('itemRate')?.value;
      const itemRate = parseFloat((itemRateRaw || '').toString().replace(/[^0-9.-]/g, '')) || 0;

      let effectiveUniversalPercent = 0;
      if (universal && universal.UDValue > 0) {
        if (universal.UDType === 2) {
          effectiveUniversalPercent = universal.UDValue;
        } else if (universal.UDType === 1 && itemRate > 0) {
          effectiveUniversalPercent = (universal.UDValue / itemRate) * 100;
        }
      }

      if (effectiveUniversalPercent <= this.discountAllPercent) {
        // DiscountAll is always applied unconditionally
        this.customerSalesForm.patchValue(
          { itemDiscType: '2', itemDiscValue: this.discountAllPercent.toFixed(4) },
          { emitEvent: false }
        );
        return;
      }
      // Universal is higher — fall through to the universal/vendor logic below
    }

    const universal = this.universalDiscount;  // { UDType: 1 ($), 2 (%), UDValue: number }
    const vendorDiscounts = this.vendorDiscountList; // [{ DiscountType: 2, DiscountPercent }]
    const itemRateRaw = this.customerSalesForm.get('itemRate')?.value;

    // Normalize itemRate
    const itemRate = parseFloat((itemRateRaw || '').toString().replace(/[^0-9.-]/g, '')) || 0;

    let selectedType: number | null = null;
    let selectedValue: number = 0;

    // Universal discount effective percent (for comparison)
    let effectiveUniversalPercent = 0;
    if (universal) {
      if (universal.UDType === 2) {
        effectiveUniversalPercent = universal.UDValue;
      } else if (universal.UDType === 1 && itemRate > 0) {
        effectiveUniversalPercent = (universal.UDValue / itemRate) * 100;
      }
    }

    // Best vendor discount
    let bestVendor: any = null;
    if (vendorDiscounts && vendorDiscounts.length > 0) {
      bestVendor = vendorDiscounts.reduce((prev, curr) =>
        curr.DiscountPercent > prev.DiscountPercent ? curr : prev
      );
    }

    // Case 1: Universal discount exists
    if (universal && universal.UDValue > 0) {
      selectedType = universal.UDType;
      selectedValue = universal.UDValue;

      if (this.applyVenDiscountaboveUd && bestVendor && bestVendor.DiscountPercent > effectiveUniversalPercent) {
        selectedType = 2; // %
        selectedValue = bestVendor.DiscountPercent;
      }
    }
    // Case 2: No universal discount → pick best vendor
    else if (bestVendor) {
      selectedType = 2; // %
      selectedValue = bestVendor.DiscountPercent;
    }

    // Patch into form if found
    if (selectedType != null) {
      this.customerSalesForm.patchValue(
        {
          itemDiscType: selectedType.toString(),
          itemDiscValue: selectedType === 2
            ? selectedValue.toFixed(4)  // % format
            : selectedValue.toFixed(2)  // $ format
        },
        { emitEvent: false }
      );
    }
  }

  getPOSSalesType() {
    this.generalService.getPOSSalesType()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.salesType = res;
        }
      });
  }

  getSalesPerson() {
    this.salesPersonService.getSalesPersonDetails()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.salesPersonData = res.filter(e => e.ActiveSalesPerson);

          const loggedInUserId = this.userService.getLoggedInUserId();
          const currentUserSalesPerson = this.salesPersonData.find(e => e.UserID === loggedInUserId);
          if (currentUserSalesPerson && this.customerSalesForm.get('salesPersonId')?.value == '0') {
            this.customerSalesForm.get('salesPersonId')?.setValue(currentUserSalesPerson.SalesmanId);
          }
        }
      });
  }

  getASCloudLicenseSettings() {
    this.generalService.getASCloudLicenseSettings()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.enableInventory = res.EnableInventoryControl ?? false;
        }
      });
  }

  getActiveUniversalDiscount() {
    this.posSalesService.getActiveUniversalDiscount()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.universalDiscount = res;
        }
      });
  }

  async validateGCNo(): Promise<boolean> {
    const enteredGCNo = this.customerSalesForm.get('gcNo')?.value?.trim();
    if (!enteredGCNo) return true; // no value — skip validation

    const existsInGrid = this.customerItemList.some((e, index) => {
      if (this.updateExistingItem && this.rowseqId && index === this.rowseqId - 1) {
        return false; // the row currently being edited — not a duplicate of itself
      }
      const gcNoInDescription = e.ItemDescription?.split('-')?.pop()?.trim();
      return gcNoInDescription === enteredGCNo;
    });

    if (existsInGrid) {
      this.showWarning($localize`Duplicate GC No. This Gift Certificate is already added to the current invoice.`);
      this.customerSalesForm.get('gcNo')?.setValue('');
      return false;
    }

    // Look up the GC# regardless of active/inactive/expired status — the
    // pre-fetched giftCertificateList only contains active GCs, so a purely
    // client-side check here would miss inactive/expired/existing numbers.
    try {
      const details = await lastValueFrom(
        this.giftCertificatesService.getGiftCertificateDetails(enteredGCNo).pipe(take(1))
      );
      if (details && this.customerSalesForm.get('gcNo')?.value?.trim() === enteredGCNo) {
        this.showWarning($localize`Duplicate GC No. This Gift Certificate already exists.`);
        this.customerSalesForm.get('gcNo')?.setValue('');
        return false;
      }
      return true;
    } catch {
      return true; // Not found (404) — the GC# is unused and available.
    }
  }

  getGiftCertificates() {
    var currentDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
    this.giftCertificatesService.getGiftCertificates(currentDate, 'Active')
      .pipe(take(1)).subscribe(res => {
        if (res) {
          this.giftCertificateList = res.map(e => ({
            ...e, // keep existing properties if needed
            ItemDescription: "Gift Certificate",
            Balance: this.customCurrency.transform(e.Balance)
          }));
        }
      })
  }

  validateStockId() {
    const stockIdControl = this.customerSalesForm.get('stockId');
    const itemDescriptionControl = this.customerSalesForm.get('itemDescription');
    const itemQtyControl = this.customerSalesForm.get('itemQty');
    const itemRateControl = this.customerSalesForm.get('itemRate');
    const vendorIdControl = this.customerSalesForm.get('vendorId');
    this.customerSalesForm.get('gcStartDate')?.setValue(this.minDate);
    if (!stockIdControl) {
      return;
    }

    const stockId = (stockIdControl.value || '').trim().toLowerCase();

    if (this.currentMenu === 'gc') {
      if (stockId === this.gcSaleTerm.toLowerCase()) {
        itemDescriptionControl?.setValue('Gift Certificate');
        itemQtyControl?.setValue(1);
      } else {
        this.showWarning($localize`Please enter a valid gift certificate term`);
        this.resetItemData();
        this.clearForm();
        return false;
      }

      if (!this.bookingExistForGCVen) {
        this.showWarning($localize`No Booking exist for this Booth Number!`);
        this.resetItemData();
        this.clearForm();
        return false;
      }

      this.vendorService.getVendorInfoByMarketVendorId(this.gcMarketVendorId)
        .pipe(take(1))
        .subscribe(res => {
          if (res?.VendorId) {
            this.vendorName = res.VendorName;
            this.vendorPhone = res.Telephone ?? "";
            this.boothList = res.CurrenyDayBookedBooths;
          }
        })

      this.customerSalesForm.patchValue({
        vendorId: this.gcMarketVendorId,
        boothId: this.gcBoothNo,
        vendorSeqId: this.gcVendorId
      }, { emitEvent: false });
    }
    else {
      this.inventoryItemDiscount = null; // set again below only if this is an inventory item
      if (stockId?.trim().toUpperCase().startsWith('CON')) {
        const normalizedStockId = stockId.trim().toUpperCase();
        const endLookup = this.beginStockLookup();
        this.consignmentService
          .getConsignmentProductForPOS(4, stockId)
          .pipe(finalize(endLookup))
          .subscribe({
            next: (res) => {
              if (!this.isStockValidationCurrent(normalizedStockId)) {
                return;
              }
              const item = res?.find(i => i.StockId?.toUpperCase() === normalizedStockId);

              if (item) {
                this.customerSalesForm.patchValue({
                  vendorId: item.VendorAlphaId,
                  vendorSeqId: item.VendorId,
                  itemRate: this.customCurrency.transform(item.Price ?? 0),
                  itemQty: 1,
                  itemDescription: item.ProductName,
                  itemCommission: item.CommisionPercent
                }, { emitEvent: false });
                this.stockImageUrl = '';
                if (this.customerSalesForm.get('barcodeScanner')?.value) {
                  this.addItemsToGrid();
                }
              } else {
                this.handleInvalidStock(stockIdControl, itemRateControl, itemQtyControl, itemDescriptionControl, normalizedStockId);
              }
            },
            error: () => {
              this.handleInvalidStock(stockIdControl, itemRateControl, itemQtyControl, itemDescriptionControl, normalizedStockId);
            }
          });
      }
      else if (this.enableInventory && stockId) {
        const normalizedStockId = stockId.trim().toUpperCase();
        const endLookup = this.beginStockLookup();
        this.inventoryService
          .getInventoryStockForPOS(4, stockId)
          .pipe(finalize(endLookup))
          .subscribe({
            next: async (res) => {
              if (!this.isStockValidationCurrent(normalizedStockId)) {
                return;
              }
              const item = res?.find(i => i.StockId?.toUpperCase() === normalizedStockId);

              if (item) {
                if (!this.isFirmItem()) {
                  this.customerSalesForm.get('itemDiscValue')?.enable();
                }
                this.customerSalesForm.patchValue({
                  vendorId: item.VenAlphaNumId,
                  vendorSeqId: item.VendorId,
                  itemRate: this.customCurrency.transform(item.Rate ?? 0),
                  itemQty: 1,
                  itemDescription: item.ItemDescription,
                  itemCommission: item.CommissionRate,
                  itemNoTax: item.NoTax,
                  itemDiscType : '2',
                  itemDiscValue: this.isFirmItem() ? '0.0000' : item.VendorDiscount
                }, {emitEvent: false });
                this.inventoryItemDiscount = item.VendorDiscount ?? null;
                this.vendorSeqId = item.VendorId;
                this.stockImageUrl = item.InventoryImageUrl ? `${item.InventoryImageUrl}?t=${Date.now()}` : '';

                if (!this.customerSalesForm.get('barcodeScanner')?.value) {
                  this.getVendorById()
                } else {
                  this.getPOSVendorActiveDiscountPlan(true);
                  this.addItemsToGrid();
                }
              }
              else {
                // stock may be unavailable because it is held by an open pending sale
                const pendingInvoiceNo = await lastValueFrom(
                  this.inventoryService.getPendingSaleInvoiceNoByStockId(normalizedStockId).pipe(take(1))
                ).catch(() => null);
                if (!this.isStockValidationCurrent(normalizedStockId)) {
                  return;
                }
                if (pendingInvoiceNo && String(pendingInvoiceNo) !== String(this.invoiceNo)) {
                  this.showWarning($localize`Stock ID ${normalizedStockId} is already added to Pending Sale #${pendingInvoiceNo}. Complete or cancel the pending sale before selling this item.`);
                  this.resetItemData();
                  this.setFocusToFirstField();
                  return;
                }

                if (this.customerSalesForm.get('barcodeScanner').value) {
                  this.handleInvalidStock(stockIdControl, itemRateControl, itemQtyControl, itemDescriptionControl, normalizedStockId);
                } else {
                  this.getVendorById();
                }
              }
            },
            error: () => {
              this.handleInvalidStock(stockIdControl, itemRateControl, itemQtyControl, itemDescriptionControl, normalizedStockId);
            }
          });
      }
      else {
        if (stockId && vendorIdControl.value) {
          this.getVendorInfoByMarketVendorId(vendorIdControl.value);
        } else if (!stockId && this.stockIdOnFocus?.trim() && vendorIdControl.value) {
          // Stock ID was removed: the stock-specific commission no longer applies
          this.resetCommissionToVendorDefault(vendorIdControl.value);
        }
      }
    }
  }

  // A Stock ID belongs to one vendor; block adding/updating the item under a different Vendor ID
  private isStockVendorMatch(stockId: string, vendorId: string, stockVendorId: string): boolean {
    const entered = (vendorId || '').toString().trim().toUpperCase();
    const owner = (stockVendorId || '').toString().trim().toUpperCase();
    if (!entered || !owner || entered === owner) {
      return true;
    }
    this.showWarning($localize`Stock ID ${stockId.trim().toUpperCase()} belongs to Vendor ID ${stockVendorId}. The vendor cannot be changed for this item.`);
    return false;
  }

  private async resetCommissionToVendorDefault(marketVendorId: string) {
    const res = await lastValueFrom(this.vendorService.getVendorInfoByMarketVendorId(marketVendorId).pipe(take(1)));
    if (res?.VendorId) {
      this.customerSalesForm.get('itemCommission')?.setValue(res.ApplyFlatComm ? res.FlatComm : this.flatCommission);
    }
  }

  private pendingStockLookup: Promise<void> | null = null;

  // Marks a Stock ID lookup as in flight; the returned callback marks it finished
  private beginStockLookup(): () => void {
    let resolveLookup: () => void;
    const lookup = new Promise<void>(resolve => (resolveLookup = resolve));
    this.pendingStockLookup = lookup;
    return () => {
      resolveLookup();
      if (this.pendingStockLookup === lookup) {
        this.pendingStockLookup = null;
      }
    };
  }

  private isStockValidationCurrent(expectedStockId: string): boolean {
    const currentStockId = (this.customerSalesForm.get('stockId')?.value || '').trim().toUpperCase();
    return !!currentStockId && currentStockId === expectedStockId;
  }

  handleInvalidStock(stockIdControl, itemRateControl, itemQtyControl, itemDescriptionControl, expectedStockId?: string) {
    const currentStockId = (stockIdControl?.value || '').trim().toUpperCase();
    if (!currentStockId) {
      return;
    }
    if (expectedStockId && currentStockId !== expectedStockId) {
      return;
    }

    this.showWarning($localize`Stock ID not found in inventory!`);
    this.resetItemData();
  }

  validateNewStockId() {
    this.loaderIcon = Promise.resolve(true);
    const newStockIdControl = this.invoiceEditForm.get('newStockId');
    if (!newStockIdControl) { this.loaderIcon = Promise.resolve(false); return; };

    const stockId = (newStockIdControl.value || '').trim().toLowerCase();
    if (!stockId) { this.loaderIcon = Promise.resolve(false); return; }

    if (stockId?.trim().toUpperCase().startsWith('CON')) {
      const normalizedStockId = stockId.trim().toUpperCase();
      this.consignmentService
        .getConsignmentProductForPOS(4, stockId)
        .subscribe({
          next: (res) => {
            if (!this.isNewStockValidationCurrent(normalizedStockId)) {
              this.loaderIcon = Promise.resolve(false);
              return;
            }
            const item = res?.find(i => i.StockId?.toUpperCase() === normalizedStockId);

            if (item) {
              this.invoiceEditForm.patchValue({
                newVendorId: item.VendorAlphaId,
                newVendorSeqId: item.VendorId,
                newComm: item.CommisionPercent,
                newItemDescription: item.ProductName
              }, { emitEvent: false });
              this.loaderIcon = Promise.resolve(false);
            } else {
              this.handleInvalidNewStock(newStockIdControl, normalizedStockId);
              this.loaderIcon = Promise.resolve(false);
            }
          },
          error: () => {
            this.handleInvalidNewStock(newStockIdControl, normalizedStockId);
            this.loaderIcon = Promise.resolve(false);
          }
        });
    }
    else if (stockId) {
      const normalizedStockId = stockId.trim().toUpperCase();
      this.inventoryService
        .getInventoryStockForPOS(4, stockId)
        .subscribe({
          next: (res) => {
            if (!this.isNewStockValidationCurrent(normalizedStockId)) {
              this.loaderIcon = Promise.resolve(false);
              return;
            }
            const item = res?.find(i => i.StockId?.toUpperCase() === normalizedStockId);

            if (item) {
              this.invoiceEditForm.patchValue({
                newVendorId: item.VenAlphaNumId,
                newVendorSeqId: item.VendorId,
                newComm: item.CommissionRate,
                newItemDescription: item.ItemDescription
              }, { emitEvent: false });
              this.loaderIcon = Promise.resolve(false);
            } else {
              this.getVendorByIdOfExistingInvoice();
            }
          },
          error: () => {
            this.loaderIcon = Promise.resolve(false);
            this.handleInvalidNewStock(newStockIdControl, normalizedStockId);
          }
        });
    }
  }

  private isNewStockValidationCurrent(expectedStockId: string): boolean {
    const currentStockId = (this.invoiceEditForm.get('newStockId')?.value || '').trim().toUpperCase();
    return !!currentStockId && currentStockId === expectedStockId;
  }

  handleInvalidNewStock(newStockIdControl, expectedStockId?: string) {
    const currentStockId = (newStockIdControl?.value || '').trim().toUpperCase();
    if (!currentStockId) {
      return;
    }
    if (expectedStockId && currentStockId !== expectedStockId) {
      return;
    }

    this.showWarning($localize`Stock ID not found in inventory!`);
    this.invoiceEditForm.patchValue({
      newItemDescription: '',
      newVendorId: '',
      newVendorSeqId: '',
      newComm: 0
    }, { emitEvent: false });
  }

  openInventoryList() {
    this.consignmentItems = [];
    this.getConsignmentProductForPOS();
    this.openModalById('consignmentInventory');
  }

  checkBookingForGCVendor() {
    this.posSalesService.checkBookingForGCVendor()
      .pipe(take(1))
      .subscribe(res => {
        this.bookingExistForGCVen = res.Success;
      })
  }

  getVendorInfoBySeqId() {
    this.vendorService.GetVendorById(this.gcVendorId)
      .pipe(take(1))
      .subscribe(res => {
        this.gcMarketVendorId = res.MarketVendorId;
      })
  }

  getPosAndUserSettings() {
    forkJoin({
      res: this.posSettingsService.getPosSettings().pipe(take(1)),
      userPermission: this.generalService.GetUserPermission().pipe(take(1))
    }).subscribe({
      next: ({ res, userPermission }) => {
        this.trackSalesbyPerson = res.OtherSettings.TrackSalesbyPerson
        this.allowVendorDiscount = res.OtherSettings.AllowVendorDiscount;
        this.posTransactionByVendor = res.OtherSettings.PosbyVendor;
        this.allowNegetiveSalesInPos = res.OtherSettings.NegativePosPayoutAmtAdjust && userPermission.UserRoles?.AllowNegativeSalesinPOS
        this.vendorBoothIDChange = userPermission.UserRoles.VendorBoothIDChange;
        this.travelerCheckTerm = res.OtherSettings.TravelerCheckTerm;
        this.defaultVendorIdChangeReason = (res.OtherSettings.DefaultVendorIdChangeReason ?? '').trim();
        this.allowVoid = res.SalesTypesSettings.AllowVoid && userPermission?.UserSalesTypes.find(x => x.SalesTypeID == 8).SalesTypeAllowed;
        if (!this.travelerCheckTerm) { this.travelerCheckTerm = "Traveler's" }

        //Gift certificate
        this.gcMaxDays = res.OtherSettings.GcmaxDays;
        this.gcSaleTerm = res.OtherSettings.GcSaleTerm;
        this.gcVendorId = res.OtherSettings.GcVendorId;
        this.gcBoothNo = res.OtherSettings.GcBoothNumber;
        this.customerSalesForm.get('gcMaxDays').setValue(this.gcMaxDays);
        this.userSalesToolbar = res.OtherSettings?.UserSalesToolbar;

        this.useBarcodeScanner = res.OtherSettings?.UseBarcodeScanner;
        this.useNoScannerDefault = res.OtherSettings?.UseNoScannerDefault;

        this.customerSalesForm.get('barcodeScanner').setValue(this.useBarcodeScanner);
        this.customerSalesForm.get('defaultNoScanner').setValue(this.useNoScannerDefault);

        this.checkBookingForGCVendor();
        this.getVendorInfoBySeqId();

        if (!this.posTransactionByVendor) {
          this.invoiceEditForm.get('editCustomerOrStock').setValue('boothId')
        }

        this.warnon100PercentDiscount = res.DiscountSettings.Warnon100PercentDiscount;
        this.warnonAnyDiscount = res.DiscountSettings.WarnonAnyDiscount;
        this.applyVenDiscountaboveUd = res.DiscountSettings.ApplyVenDiscountaboveUd

        //Layaway settings
        this.downPaymentPercent = res.LayawaySettings.DownPaymentPercent;
        this.layawayNumberOfDays = res.LayawaySettings.LayawayNumberOfDays;
        this.numberOfInstalments = res.LayawaySettings.NumberOfInstalments;
        this.layawayMessage = res.LayawaySettings.LayawayMessage;

        this.defCustIdForRetail = res.SalesTypesSettings.DefCustIdForRetail;
        this.custIdReqPendingSale = res.SalesTypesSettings.CustIdReqPendingSale;
        this.defCustIdForPendingSale = res.SalesTypesSettings.DefCustIdForPendingSale;

        //Bag settings
        this.enableBag = !!res.OtherSettings?.EnableBag && !!res.OtherSettings?.BagVendorId;
        this.bagVendorSeqId = res.OtherSettings?.BagVendorId ?? null;
        this.bagPrice = Number(res.OtherSettings?.BagPrice) || 0;
        this.bagTaxable = !!res.OtherSettings?.BagTaxable;
        this.bagBoothNo = (res.OtherSettings?.BagBoothNumber || '').trim();
        if (this.enableBag) {
          this.vendorService.GetVendorById(this.bagVendorSeqId)
            .pipe(take(1))
            .subscribe(vendor => {
              this.bagMarketVendorId = vendor?.MarketVendorId ?? '';
              this.bagVendorName = vendor?.VendorName ?? '';
            });
        }

        this.customerSalesForm.patchValue({
          downPaymentPercent: this.downPaymentPercent,
          downPaymentMaxDays: this.layawayNumberOfDays,
          installmentNo: this.numberOfInstalments
        })
      }
    });
  }

  getSalesTaxAndCommissionSettings() {
    this.posSettingsService.getSalesTaxAndCommission()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.applySalesTax = res.TaxSettings.ApplyPossalesTax;
          this.applySalesTaxOnSecLvlTax = res.TaxSettings.ApplyOnPossalesTax;
          this.applySecLvlTax = res.TaxSettings.ApplyPossecondLevelTax;
          this.salesTaxPercent = res.TaxSettings.PossalesTaxPercent;
          this.secondLevelTaxPercent = res.TaxSettings.PossecondLevelTaxPercent;
          this.secondLevelTaxName = res.TaxSettings.PossecondLevelTaxName ? res.TaxSettings.PossecondLevelTaxName : "Sec Level Tax";;
          this.applySalesTaxItemWise = res.TaxSettings.ApplyPostaxItemwise;
          if (this.currentMenu == "2") {
            this.applySalesTaxItemWise = false;
          }
          this.fillDefaultIteminPos = res.POSSales.FillDefaultIteminPos;
          this.defaultItemName = res.POSSales.DefaultItemName;
          this.allowPossalesWithOutBooking = res.POSSales.AllowPossalesWithOutBooking;
          this.enableOtherChargeinPos = res.POSSales.EnableOtherChargeinPos;
          this.posotherChargeName = res.POSSales.PosotherChargeName ?? "Other Charges";
          this.allowCommissionOverride = res.Commission.AllowCommissionOverride;
          if (this.allowCommissionOverride) {
            this.customerSalesForm.get('itemCommission').enable();
          }
          this.flatCommission = res.Commission.FlatCommission;
          this.showCommissiononPos = res.Commission.ShowCommissiononPos;
          this.customerSalesForm.get('itemCommission').setValue(this.flatCommission);
        }
      });
  }

  checkStockId() {
    if (this.enableInventory && this.customerSalesForm.get('barcodeScanner').value) {
      this.onEnterStockId();
    }
  }

  vendorIdEnterClick(inputtedVal) {
    if (this.enableInventory && this.customerSalesForm.get('barcodeScanner').value && inputtedVal) {
      this.getEnteredVendorDetails(inputtedVal);
    }
  }

  getEnteredVendorDetails(inputtedVal) {
    if (this.enableInventory && this.customerSalesForm.get('barcodeScanner').value && inputtedVal) {
      this.customerSalesForm.get('stockId')
        .setValue(inputtedVal, { emitEvent: false });
      this.validateStockId();
    }
    else {
      this.customerSalesForm.get('itemDiscValue')?.setValue(0);
      this.getVendorInfoByMarketVendorId(inputtedVal)
    }
  }

  clearVendorField() {
    this.customerSalesForm.patchValue({
      vendorId: '',
      vendorSeqId: '',
      boothId: ''
    }, { emitEvent: false });
    this.clearForm();
  }

  getVendorInfoByMarketVendorId(marketVendorId: string, byVendorSearch = false) {
    if (marketVendorId != null && marketVendorId != undefined && marketVendorId != '') {
      this.loaderIcon = Promise.resolve(true);
      this.vendorService.getVendorInfoByMarketVendorId(marketVendorId)
        .pipe(take(1))
        .subscribe(async res => {
          if (res?.VendorId) {
            this.vendorName = res.VendorName;
            this.vendorPhone = res.Telephone ?? "";
            if (res.IsInactive) {
              this.showWarning($localize`Inactive Vendor. Please select a valid vendor.`);
              this.loaderIcon = Promise.resolve(false);
              this.clearVendorField();
              return;
            }
            this.customerSalesForm.get('vendorComments')?.setValue(res.VendorCommment);
            if (!this.posTransactionByVendor || this.antiqueVillageChanges) {
              const boothId = this.customerSalesForm.get('boothId')?.value;

              // Normalize values for case-insensitive comparison
              const boothIdLower = boothId?.trim()?.toString().toLowerCase();
              const bookedBooths = res.CurrenyDayBookedBooths
                ? res.CurrenyDayBookedBooths.split(',').map((b: string) => b.trim().toLowerCase())
                : [];

              if (boothIdLower && !bookedBooths.includes(boothIdLower)) {
                this.showWarning($localize`Booking with this booth ID does not exist.`);
                this.customerSalesForm.patchValue({
                  vendorId: '',
                  vendorSeqId: '',
                  boothId: ''
                }, { emitEvent: false });
                this.loaderIcon = Promise.resolve(false);
                this.clearForm();
                return;
              }
              this.boothList = res.CurrenyDayBookedBooths;
            } else {
              this.boothList = res.CurrenyDayBookedBooths;
              if (!this.allowPossalesWithOutBooking && !this.boothList) {
                this.showWarning($localize`No Booking exist for this Vendor ID.`);
                this.loaderIcon = Promise.resolve(false);
                this.clearVendorField();
                return;
              }
            }

            // Commission logic
            var commission = 0;
            var vendorCommission = res.ApplyFlatComm ? res.FlatComm : this.flatCommission;
            var stockId = "";
            if (this.editInvoiceOpen) {
              stockId = this.invoiceEditForm.get('newStockId').value;
            } else {
              stockId = this.customerSalesForm.get('stockId').value;
            }
            const normalizedStockId = stockId.trim().toUpperCase();
            if (stockId) {
              if (stockId?.trim().toUpperCase().startsWith('CON')) {
                var consignItem = await lastValueFrom(this.consignmentService.getConsignmentProductForPOS(4, stockId).pipe(take(1)));
                const item = consignItem?.find(i => i.StockId?.toUpperCase() === normalizedStockId);
                if (item) {
                  commission = item.CommisionPercent;
                }
              } else {
                var inventoryItem = await lastValueFrom(this.inventoryService.getInventoryStockForPOS(4, stockId).pipe(take(1)));
                const item = inventoryItem?.find(i => i.StockId?.toUpperCase() === normalizedStockId);
                if (item) {
                  commission = item.CommissionRate;
                } else {
                  commission = vendorCommission;
                }
              }
            } else if (this.currentMenu != 'gc') {
              commission = res.ApplyFlatComm ? res.FlatComm : this.flatCommission;
            }

            this.customerSalesForm.get('itemCommission')?.setValue(commission);

            if (this.editInvoiceOpen) {
              this.invoiceEditForm.get('newComm')?.setValue(commission);
            }

            // Vendor info
            if (!this.editInvoiceOpen) {
              this.customerSalesForm.patchValue({
                vendorId: res.MarketVendorId,
                vendorSeqId: res.VendorId
              }, { emitEvent: false });
              this.vendorSeqId = res.VendorId;
            }

            if (this.editInvoiceOpen) {
              this.invoiceEditForm.patchValue({
                newVendorId: res.MarketVendorId,
                newVendorSeqId: res.VendorId,
                newComm: commission
              }, { emitEvent: false });
            } else {
              this.searchField = 5;
              this.searchValue = res.MarketVendorId;
              this.getConsignmentProductForPOS();
              const itemQty = this.customerSalesForm.get('itemQty').value;
              if (!itemQty && itemQty == 0) {
                this.customerSalesForm.get('itemQty').setValue(1);
              }
              if (byVendorSearch) {
                setTimeout(() => {
                  this.vendorIdField.nativeElement.focus();
                }, 10);
              }
            }
            this.getPOSVendorActiveDiscountPlan(false);
          } else {
            this.posTransactionByVendor ?
              this.showWarning(this.wordReplacePipe.transform($localize`Vendor ID does not exist.`)) :
              this.showWarning($localize`Booking with this booth ID does not exist.`);
            this.clearForm();
            this.customerSalesForm.patchValue({
              vendorId: '',
              vendorSeqId: '',
              boothId: ''
            }, { emitEvent: false });
            if (this.editInvoiceOpen) {
              this.invoiceEditForm.patchValue({
                newVendorId: '',
                newVendorSeqId: '',
                newComm: 0
              }, { emitEvent: false });
            }
          }
          this.loaderIcon = Promise.resolve(false);
        }, err => {
          this.loaderIcon = Promise.resolve(false);
        });
    }
  }

  VendorInfo(data) {
    if (this.editInvoiceOpen) {
      this.invoiceEditForm.get('newVendorId').setValue(data.marketVendorId);
      this.invoiceEditForm.get('newVendorSeqId').setValue(data.vendorId);
      !this.posTransactionByVendor ? this.invoiceEditForm.get('newBoothId').setValue(data.boothNumber) : "";
      this.getVendorInfoByMarketVendorId(data.marketVendorId, true);
    } else {
      this.customerSalesForm.get('vendorId').setValue(data.marketVendorId)
      // !this.posTransactionByVendor ? this.customerSalesForm.get('boothId').setValue(data.boothNumber) : "";
      this.customerSalesForm.get('boothId').setValue(data.boothNumber)
      this.customerSalesForm.get('vendorSeqId').setValue(data.vendorId);
      this.customerSalesForm.get('vendorComments')?.setValue(data.VendorCommment);
      this.vendorName = data.vendorName;
      this.vendorSeqId = data.vendorId;
      this.boothList = data?.boothList;
      const formValue = this.customerSalesForm;
      const itemDescription = formValue.get('itemDescription').value;
      const itemQty = formValue.get('itemQty').value;
      if (this.fillDefaultIteminPos && !itemDescription) {
        this.customerSalesForm.get('itemDescription').setValue(this.defaultItemName);
      }
      if (!itemQty && itemQty == 0) {
        this.customerSalesForm.get('itemQty').setValue(1);
      }
      this.customerSalesForm.get('itemDiscValue')?.setValue(0);
      this.getPOSVendorActiveDiscountPlan(false);
      this.getVendorInfoByMarketVendorId(data.marketVendorId, true);
    }
    this.onVendorModalClose(); // closes the popup and resets its search criteria/results
  }

  async getVendorById() {
    var vendorId = this.customerSalesForm.get('vendorId').value;
    const itemDescription = this.customerSalesForm.get('itemDescription').value;
    if (this.fillDefaultIteminPos && !itemDescription) {
      this.customerSalesForm.get('itemDescription').setValue(this.defaultItemName);
    }
    if (!this.posTransactionByVendor) {
      const boothId = this.customerSalesForm.get('boothId').value;
      var res = await lastValueFrom(this.vendorService.getVendorIdbyBoothNoForCurrentDay(boothId).pipe(take(1)));
      if (res) {
        vendorId = res.MarketVendorId;
      }
    }
    this.getPOSVendorActiveDiscountPlan(false);
    this.getVendorInfoByMarketVendorId(vendorId);
  }

  onStockIdKeyDown(event: KeyboardEvent): void {
    const allowedPattern = /^[a-zA-Z0-9\-]$/;
    const controlKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
      'Tab', 'Home', 'End'
    ];

    if (controlKeys.includes(event.key)) return; // always allow control keys

    if (!allowedPattern.test(event.key)) {
      event.preventDefault(); // block everything else, including spaces
    }
  }

  // Strips spaces and other disallowed characters that bypass keydown (paste, drop, autofill)
  onStockIdInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(/[^a-zA-Z0-9\-]/g, '');
    if (cleaned !== input.value) {
      this.customerSalesForm.get('stockId')?.setValue(cleaned);
    }
  }

  checkHasAnyItemToAddOrUpdate() {
    let {
      vendorId,
      boothId,
      stockId,
      itemDescription,
      itemQty,
      itemRate,
      itemDiscValue,
      gcNo,
    } = this.customerSalesForm.value;

    const rawrate = this.getActualAmountFromInp(itemRate);
    const values = [
      vendorId, boothId, stockId,
      itemDescription, itemQty, rawrate,
      parseFloat(itemDiscValue), gcNo,
    ];
    const hasAnyValue = values.some(v =>
      v !== null &&
      v !== undefined &&
      v !== '' &&
      v !== 0 &&
      v !== '$0.00' &&
      !Number.isNaN(v)
    );
    return hasAnyValue;
  }

  rowDataClick(data, index) {
    const skipUnsavedCheck = this.currentMenu == 'gc' && this.bindNewGCData;
    if (skipUnsavedCheck) {
      this.bindNewGCData = false;
    }
    const hasAnyValue = !skipUnsavedCheck && this.checkHasAnyItemToAddOrUpdate();

    if (hasAnyValue) {
      this.showWarning("Please update or cancel the item and proceed.");
      return;
    }
    var stockId = data.StockId;
    if (this.invoiceNo == 'New' || !this.invoiceNo || this.currentMenu == '6' || this.pendingSale) {
      this.rowseqId = index + 1;
      this.addNewItem = false;
      this.updateExistingItem = true;
      this.searchField = 5;
      this.searchValue = data.VendorId;
      this.stockImageUrl = data.StockImageUrl || '';

      this.customerSalesForm.patchValue({
        vendorId: data.VendorId,
        vendorSeqId: data.VendorSeqId,
        stockId: data.StockId,
        boothId: data.BoothId,
        itemDescription: data.ItemDescription,
        itemQty: data.ItemQty,
        itemRate: data.ItemRate,
        itemNoTax: data.ItemNoTax || data.TaxNotApplied,
        itemDiscType: '2',
        itemDiscValue: data.ItemDiscValue,
        itemFirm: data.ItemFirm || false,
        gcNo: this.currentMenu == 'gc' ? data.ItemDescription?.split('-')?.pop()?.trim() : "",
        itemCommission: data.ItemCommission || 0
      })

      // Reset discount state for the newly selected item's vendor
      this.vendorSeqId = data.VendorSeqId;
      this.inventoryItemDiscount = data.InventoryDiscount ?? null;
      this.vendorDiscountList = [];
      this.vendorDiscountText = '';
      this.discountAllPercent = null;
      this.showDropdown = false;
      this.noDiscountPlan = false;
      if (data.VendorSeqId) {
        this.getPOSVendorActiveDiscountPlan(false, true);
      }
    }
    else if (!stockId?.toUpperCase().startsWith('CON')) {
      this.editInvoice(data);
    }
  }

  editInvoice(data) {
    this.editInvoiceOpen = true;
    if (this.currentMenu != '6' && this.currentMenu != '7' && this.currentMenu != '8' && !this.pendingSale) {
      this.invoiceEditForm.patchValue({
        existingVendorId: data.VendorId,
        existingVendorSeqId: data.VendorSeqId,
        existingQty: data.ItemQty,
        existingRate: data.ItemRate,
        existingItemDescription: data.ItemDescription,
        existingBoothId: data.BoothId,
        invoiceNumber: this.invoiceNo,
        invoiceItemId: data.InvoiceItemId,
        newItemDescription: data.ItemDescription,
        ItemSerialNumber: data.SerialNumber,
        existingStockId: data.StockId,
        changeReason: this.defaultVendorIdChangeReason
      })
      if (this.vendorBoothIDChange) {
        this.allowCommissionOverride ? this.invoiceEditForm.get('newComm')?.enable() : this.invoiceEditForm.get('newComm')?.disable();
        this.openModalById('invoiceEditModal');
      }
    }
    else if (this.currentMenu == '6') {
      this.pendingSale = true;
    }
  }

  closeInvoiceEditModel() {
    this.invoiceEditForm.reset();
    this.invoiceEditForm.get('editCustomerOrStock')?.setValue(this.posTransactionByVendor ? 'customer' : 'boothId');
    this.posTransactionByVendor ? this.invoiceEditForm.get('newVendorId')?.enable() : this.invoiceEditForm.get('newBoothId')?.enable();
    const modal = this.invoiceEditModal.nativeElement;
    this.closeModal(modal);
  }

  async addItemsToGrid() {
    if (this.isAddingItemToGrid) {
      return;
    }
    this.isAddingItemToGrid = true;
    try {
      // Clicking Add/Update right after typing a Stock ID fires its blur lookup first; wait for it so the
      // item is saved with the stock's details instead of the values that were in the form before the lookup
      if (this.pendingStockLookup) {
        await this.pendingStockLookup;
      }
      await this.addItemsToGridInternal();
    } finally {
      this.isAddingItemToGrid = false;
    }
  }

  private async addItemsToGridInternal() {
    this.showDropdown = false;
    if (this.currentMenu == "2") {
      this.customerSalesForm.get('itemNoTax').setValue(true);
    }
    let {
      vendorId,
      boothId,
      vendorSeqId,
      stockId,
      itemDescription,
      itemQty,
      itemRate,
      itemDiscValue,
      itemDiscType,
      itemFirm,
      gcNo,
      gcStartDate,
      gcMaxDays,
      gcExpiryDate
    } = this.customerSalesForm.value;

    if (itemFirm) {
      itemDiscValue = 0;
    }

    var itemNoTax = this.customerSalesForm.get('itemNoTax').value;
    var itemCommission = this.customerSalesForm.get('itemCommission').value;

    if (this.enableInventory && stockId) {
      var stockData = await lastValueFrom(this.inventoryService.getInventoryStockForPOS(4, stockId));
      if (stockData && stockData.length > 0) {
        const normalizedStockId = stockId.trim().toUpperCase();
        const item = stockData?.find(i => i.StockId?.toUpperCase() === normalizedStockId);
        if (item) {
          var totalStockQty = itemQty || 0;
          var availableStock = item.CurrentStock;
          if (this.customerItemList.length > 0) {
            if (this.updateExistingItem && this.rowseqId) {
              var exitingStockQtyInGrid = this.customerItemList
                .filter((item, index) => item.StockId === stockId && index !== this.rowseqId - 1)
                .reduce((sum, item) => sum + (item.ItemQty || 0), 0);
            } else {
              var exitingStockQtyInGrid = this.customerItemList
                .filter(item => item.StockId === stockId)
                .reduce((sum, item) => sum + (item.ItemQty || 0), 0);
            }
            availableStock = item.CurrentStock - exitingStockQtyInGrid;
            totalStockQty = totalStockQty + exitingStockQtyInGrid;
          }
          if (availableStock < itemQty) {
            this.showWarning($localize`Insufficient stock. The quantity of the available item is ${availableStock}.`);
            this.resetItemData();
            this.setFocusToFirstField();
            return;
          }
          if (!this.isStockVendorMatch(stockId, vendorId, item.VenAlphaNumId)) {
            return;
          }
        }
      }
    }

    // Consignment items also belong to a fixed vendor
    if (stockId && vendorId && stockId.trim().toUpperCase().startsWith('CON')) {
      const normalizedConStockId = stockId.trim().toUpperCase();
      const conData = await lastValueFrom(this.consignmentService.getConsignmentProductForPOS(4, stockId).pipe(take(1)));
      const conItem = conData?.find(i => i.StockId?.toUpperCase() === normalizedConStockId);
      if (conItem && !this.isStockVendorMatch(stockId, vendorId, conItem.VendorAlphaId)) {
        return;
      }
    }

    const warn = (msg: string, focusField?: () => void) => {
      Swal.fire({
        text: msg,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
        didClose: () => {
          if (focusField) {
            setTimeout(() => focusField(), 0); // ensure DOM is ready
          }
        }
      });
    };

    itemRate = this.getActualAmountFromInp(itemRate);
    // Validation

    if (!vendorId && !boothId && this.currentMenu != 'gc') {
      return warn($localize`Please enter the item details`,
        () => this.itemRateInput.nativeElement.focus());
    }

    if (this.antiqueVillageChanges && !stockId) {
      return warn($localize`Please provide Item Stock ID`,
        () => this.stockIdInput.nativeElement.focus());
    }

    if (this.antiqueVillageChanges && !boothId?.trim()) {
      return warn(this.wordReplacePipe.transform($localize`Please provide Booth ID`));
    }

    if (vendorId) {
      var res = await lastValueFrom(this.vendorService.getVendorInfoByMarketVendorId(vendorId).pipe(take(1)));
      if (!res?.VendorId) {
        return false;
      }
      // Items picked from the Stock ID search / barcode never pass through the vendor-field check, so guard here
      if (res.IsInactive) {
        this.showWarning($localize`Inactive Vendor. Please select a valid vendor.`);
        this.resetItemData(); // clears only the item entry row; keeps customer and grid intact
        this.customerSalesForm.patchValue({ vendorSeqId: '' }, { emitEvent: false });
        this.setFocusToFirstField();
        return false;
      }
    }

    itemDescription = (itemDescription || '').trim(); // reject whitespace-only descriptions
    if (!itemDescription) {
      return warn($localize`Please provide the item description`,
        () => this.itemDescriptionInput.nativeElement.focus());
    }

    if (!itemQty) {
      return warn($localize`Provide the Item Qty`,
        () => this.itemQtyInput.nativeElement.focus());
    }
    else if (!this.allowNegetiveSalesInPos && itemQty < 0) {
      return warn($localize`Qty should be greater than 0`,
        () => this.itemQtyInput.nativeElement.focus());
    }

    if (!itemRate) {
      return warn($localize`Please enter the item details`,
        () => this.itemRateInput.nativeElement.focus());
    }

    const qty = Number(itemQty) || 0;
    const rate = Number(itemRate) || 0;
    const totalItemRate = +(qty * rate).toFixed(2);

    // Calculate discount %
    let discountPercent = itemDiscType == "1"
      ? totalItemRate > 0
        ? (Number(itemDiscValue) || 0) / totalItemRate * 100
        : 0
      : Number(itemDiscValue) || 0;

    discountPercent = +discountPercent.toFixed(4);

    // Confirm if discount ≥ 100%
    if (this.warnon100PercentDiscount && discountPercent >= 100) {
      const result = await Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Discount percentage is greater than or equal to 100. Do you want to continue?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`
      });

      if (!result.isConfirmed) return;
    }
    else if (this.warnonAnyDiscount && discountPercent > 0) {
      const result = await Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Do you want to add ${discountPercent}% discount?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`
      });

      // Declining the auto-applied discount shouldn't block adding the item; add it at 0% instead.
      if (!result.isConfirmed) discountPercent = 0;
    }

    const discountAmount = discountPercent > 0 ? + this.roundToTwo(totalItemRate * discountPercent / 100) : 0;
    const discountedPrice = +(totalItemRate - discountAmount).toFixed(2);

    // Taxes
    let salesTax = 0, secLvlTax = 0;
    if (this.applySalesTaxItemWise && !itemNoTax) {
      if (this.applySalesTax) salesTax = +(discountedPrice * (this.salesTaxPercent / 100)).toFixed(2);
      if (this.applySecLvlTax) secLvlTax = +(discountedPrice * (this.secondLevelTaxPercent / 100)).toFixed(2);
    }

    if (this.applySalesTaxItemWise) {
      var netPrice = +(discountedPrice + salesTax + secLvlTax).toFixed(2);
    } else {
      netPrice = +(discountedPrice).toFixed(2);
    }

    const fmt = (num: number) => this.customCurrency.transform(num.toString());

    if (this.currentMenu == 'gc') {
      const isGCNoValid = await this.validateGCNo();
      if (!isGCNoValid) {
        return;
      }
      // Remove existing "-gcNo" suffix if already appended (e.g. during update)
      if (itemDescription?.includes('-')) {
        itemDescription = itemDescription.split('-')[0].trim();
      }
      itemDescription = itemDescription + "-" + gcNo;
    }
    if (this.updateExistingItem && this.rowseqId) {
      const index = this.rowseqId - 1;
      this.customerItemList[index] = {
        VendorId: vendorId,
        BoothId: boothId,
        VendorSeqId: vendorSeqId,
        StockId: stockId,
        ItemDescription: itemDescription,
        ItemQty: qty,
        ItemRate: fmt(rate),
        ItemTotalRate: fmt(totalItemRate),
        ItemDiscValue: discountPercent,
        ItemDiscAmount: fmt(discountAmount),
        ItemDiscountedPrice: fmt(discountedPrice),
        ItemNetprice: fmt(netPrice),
        ItemSalesTax: fmt(salesTax),
        ItemSecLvlTax: fmt(secLvlTax),
        VendorName: this.vendorName,
        BoothList: this.boothList,
        ItemCommission: itemCommission,
        InvoiceItemId: this.customerItemList[index]?.InvoiceItemId,
        Selected: false,
        GCStartDate: gcStartDate,
        GCExpiryDate: gcExpiryDate,
        GCMaxDays: gcMaxDays,
        ItemNoTax: itemNoTax,
        ItemFirm: itemFirm,
        StockImageUrl: this.stockImageUrl,
        InventoryDiscount: this.inventoryItemDiscount,
        IsBag: this.customerItemList[index]?.IsBag
      };

      this.rowseqId = 0;
      this.updateExistingItem = false;
      this.addNewItem = true;
    } else {
      this.customerItemList.push({
        VendorId: vendorId,
        BoothId: boothId,
        StockId: stockId,
        ItemDescription: itemDescription,
        ItemQty: qty,
        ItemRate: fmt(rate),
        ItemTotalRate: fmt(totalItemRate),
        ItemDiscValue: discountPercent,
        ItemDiscAmount: fmt(discountAmount),
        ItemDiscountedPrice: fmt(discountedPrice),
        ItemNetprice: fmt(netPrice),
        ItemSalesTax: fmt(salesTax),
        ItemSecLvlTax: fmt(secLvlTax),
        VendorName: this.vendorName,
        BoothList: this.boothList,
        VendorSeqId: vendorSeqId,
        ItemCommission: itemCommission,
        Selected: false,
        GCStartDate: gcStartDate,
        GCExpiryDate: gcExpiryDate,
        GCMaxDays: gcMaxDays,
        ItemNoTax: itemNoTax,
        ItemFirm: itemFirm,
        StockImageUrl: this.stockImageUrl,
        InventoryDiscount: this.inventoryItemDiscount
      });
    }

    if (this.currentMenu == '5') {
      this.calculateLayaway();
    }

    this.resetItemData();
    this.setFocusToFirstField();

    if (this.currentMenu == 'gc') {
      this.customerSalesForm.get('stockId').setValue(this.gcSaleTerm);
      this.validateStockId();
      this.bindNewGCData = true;
    }
  }

  voidLayawaySale() {
    this.cancelLayawaySaleClicked = false;
    this.selectedOptionBeforePasscodeAuth = this.currentMenu;
    this.PassCodeAuthentication.OpenModal();
  }

  async closeLayawaySale() {
    var result = await Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you want to close layaway sale?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`
    });

    if (result.isConfirmed) {
      this.selectedOptionBeforePasscodeAuth = '5';
      this.cancelLayawaySaleClicked = true;
      this.PassCodeAuthentication.OpenModal();
    };
  }

  closeLayawayConfirmed() {
    this.posSalesService.closeLayawaySale(this.seqInvoiceNo)
      .pipe(take(1))
      .subscribe(res => {
        if (res.Success)
          this.toastr.success($localize`Layaway sale closed successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        else
          this.toastr.error($localize`Error while closing Layaway Sale`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
      })
    this.hideCheckout = true;
    this.saleStatus = "Closed";
  }

  closeDiscountModal() {
    this.discountCouponPercent = '0.00';
    this.closeModalById('modalDiscountCoupon');
  }

  async applyCouponDiscount() {
    if (this.discountCouponPercent > 100) {
      this.showWarning($localize`Discount value cannot be greater than 100.`);
      return;
    }
    else if (this.warnon100PercentDiscount && this.discountCouponPercent == 100) {
      const result = await Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Discount percentage is equal to 100. Do you want to continue?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`
      });

      if (!result.isConfirmed) return;
    }

    var result = await Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure to apply the discount to all items in the list?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`
    });

    if (!result.isConfirmed) {
      this.closeModalById('modalDiscountCoupon');
      return;
    };
    if (!this.discountCouponPercent || this.discountCouponPercent <= 0) {
      this.showWarning($localize`Please enter a discount value greater than 0.`);
      return;
    }

    this.customerItemList = this.customerItemList.map(item => {
      // Bag line is never discounted
      if (this.isBagLine(item)) {
        return item;
      }
      const currentDiscount = parseFloat(item.ItemDiscValue) || 0;

      // Only apply coupon if it gives a higher discount
      const itemTotalRate = this.getActualAmountFromInp(item.ItemTotalRate);
      const discountAmount = (itemTotalRate * this.discountCouponPercent) / 100;
      const discountedPrice = itemTotalRate - discountAmount;

      return {
        ...item,
        ItemDiscValue: this.discountCouponPercent,
        ItemDiscAmount: this.fmt(discountAmount),
        ItemDiscountedPrice: this.fmt(discountedPrice)
      };
      // Keep item unchanged if coupon discount is not higher
      return item;
    });
    this.updateTaxesForAllItems();
    this.closeModalById('modalDiscountCoupon');
    this.discountCouponPercent = '0.00';
  }

  fmt(num) {
    const fmt = num != null ? this.customCurrency.transform(num.toString()) : '';
    return fmt;
  }

  setFocusToFirstField() {
    setTimeout(() => {
      if (this.vendorIdField?.nativeElement) {
        this.vendorIdField.nativeElement.focus();
        this.vendorIdField.nativeElement.select();
      } else if (this.boothId?.nativeElement) {
        this.boothId.nativeElement.focus();
        this.boothId.nativeElement.select();
      }
    }, 0)
  }

  resetPageData() {
    this.customerItemList = [];
    this.loadedOrgItemList = [];
    if (this.currentMenu != '6') {
      this.resetInvoiceNo();
    }
    this.pendingSale = false;
    this.vendorDiscountText = '';
    this.noDiscountPlan = false;
    this.isScrapReasonVisible = false;
    this.menuService.setMenu('1');
    this.saleStatus = "New";
    this.clearForm();
    this.setFocusToFirstField();
  }

  passcodeAuthenciateRes(val) {
    const scrapReason = this.customerSalesForm.get('scrapReason').value;
    if (val == false) {
      const gridSaleType = this.customerItemList[0] ? this.customerItemList[0]?.SaleType.toString() : '0';
      if (gridSaleType != '7' && gridSaleType != '8' && gridSaleType != '6') {
        this.menuService.setMenu(gridSaleType.toString());
      }
      else {
        this.cancelResetValues();
      }
    }
    else {
      this.menuService.setMenu(this.selectedOptionBeforePasscodeAuth);
      if (this.selectedOptionBeforePasscodeAuth == '5') {
        if (this.cancelLayawaySaleClicked) {
          this.closeLayawayConfirmed();
        } else {
          var layawayReceiptDetails = this.layawayInvoiceDetails.LayawayAmountPaidDetails;
          var installmentDetails = layawayReceiptDetails.filter(e => e.ReceiptType == "LAYINSTLMT")
          const totalInstallmentsPaid = installmentDetails
            ?.reduce((sum, item) => sum + (item.AmountPaid || 0), 0) || 0;

          const latestInstallmentAmt = installmentDetails?.[0]?.AmountPaid || 0;

          var downPaymentAmt = layawayReceiptDetails.filter(e => e.ReceiptType == "LAYDNPAYT")?.reduce((sum, item) => sum + (item.AmountPaid || 0), 0) || 0;

          this.layawayReceiptIds = layawayReceiptDetails;

          var layawayDefaultReceiptId = this.layawayReceiptIds[0]?.SalesRectId;
          var receiptAmount = this.layawayReceiptIds[0]?.AmountPaid;

          const totalPaymentsReceived = downPaymentAmt + totalInstallmentsPaid;
          this.voidLayawayForm.patchValue({
            downPaymentReceived: this.customCurrency.transform(downPaymentAmt),
            installmentPayReceived: this.customCurrency.transform(totalInstallmentsPaid),
            LastestinstallmentReceived: this.customCurrency.transform(latestInstallmentAmt),
            TotalPaymentReceived: this.customCurrency.transform(totalPaymentsReceived),
            LayawayReceipt: layawayDefaultReceiptId,
            LayawayReceiptAmount: this.customCurrency.transform(receiptAmount)
          })
          this.openModalById('layawayVoidModel');
        }
      }

      if (this.selectedOptionBeforePasscodeAuth == '6' && this.isScrapReasonVisible && scrapReason) {
        this.savePendingSale(true);
      }
    }
  }

  loadLayawayReceiptAmount() {
    var receiptAmount = this.layawayReceiptIds.find(e => e.SalesRectId == this.voidLayawayForm.get('LayawayReceipt').value)?.AmountPaid;
    this.voidLayawayForm.get('LayawayReceiptAmount').setValue(this.customCurrency.transform(receiptAmount));
  }

  onLayawayReceiptSelectionChange(receiptId: number | null) {
    this.currentSalesReceiptId = receiptId ?? this.layawayReceiptDropdown[0]?.SalesRectId ?? 0;
  }

  voidLayawayDetails() {
    var voidLayawayForm = this.voidLayawayForm.value;
    if (!voidLayawayForm.reasonForLayawayVoid) {
      this.showWarning($localize`Please enter the reason for voiding the installments`);
      return false;
    }
    this.loaderIcon = Promise.resolve(true);
    var layawayReceiptDetails = this.layawayInvoiceDetails.LayawayAmountPaidDetails;
    var selectedReceiptType = layawayReceiptDetails.find(e => e.SalesRectId == voidLayawayForm.LayawayReceipt)?.ReceiptType;
    var installmentDetails = layawayReceiptDetails.filter(e => e.ReceiptType == "LAYINSTLMT");
    if (selectedReceiptType == "LAYDNPAYT" && installmentDetails.length > 0) {
      this.showWarning($localize`Please void all the installments before voiding downpayment`);
      this.loaderIcon = Promise.resolve(false);
      return false;
    }

    this.posSalesService.voidLayawaySale(voidLayawayForm.LayawayReceipt, voidLayawayForm.reasonForLayawayVoid).pipe(take(1))
      .subscribe(res => {
        if (res.Success) {
          this.toastr.success($localize`Payment voided successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        }
        this.voidLayawayForm.get('reasonForLayawayVoid').setValue("");
        this.closeModalById("layawayVoidModel")
        this.cancelResetValues();
        this.loaderIcon = Promise.resolve(false);
      });
  }

  async voidEntireLayaway() {
    const reason = (this.voidLayawayForm.get('reasonForLayawayVoid')?.value || '').trim();
    if (!reason) {
      this.showWarning($localize`Please enter the reason for voiding the layaway`);
      return;
    }
    const totalPaid = this.voidLayawayForm.get('TotalPaymentReceived')?.value;
    const result = await Swal.fire({
      title: $localize`Confirm`,
      text: $localize`All payments of this layaway (${totalPaid}) will be voided and the layaway will be closed. Do you want to continue?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`
    });
    if (!result.isConfirmed) {
      return;
    }

    this.loaderIcon = Promise.resolve(true);
    this.posSalesService.voidEntireLayaway(this.seqInvoiceNo, reason).pipe(take(1))
      .subscribe({
        next: res => {
          this.loaderIcon = Promise.resolve(false);
          if (!res?.Success) {
            this.showWarning(res?.Message || $localize`Unable to void the layaway`);
            return;
          }
          this.toastr.success($localize`Layaway voided successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          this.voidLayawayForm.get('reasonForLayawayVoid').setValue("");
          this.closeModalById("layawayVoidModel");
          this.cancelResetValues();
        },
        error: () => {
          this.loaderIcon = Promise.resolve(false);
        }
      });
  }

  clearForm() {
    this.customerSalesForm.patchValue({
      salesPersonId: '0',
      scrapReason: '',
      selectedPendingSale: '0',
      otherCharge: '$0.00',
      getTotalInvoiceAmount: '$0.00',
      downPaymentPercent: this.downPaymentPercent,
      downPaymentMaxDays: this.layawayNumberOfDays,
      installmentNo: this.numberOfInstalments,
      vendorComments: ''
    });
    this.clearGeneralFormInfo();
  }

  clearGeneralFormInfo() {
    this.vendorName = "";
    this.boothList = "";
    this.customerData = "";
    this.shipperData = "";
    this.customerId = "";
    this.shipperId = null;
    this.vendorPhone = "";
  }

  resetInvoiceNo() {
    this.invoiceNo = "";
    this.seqInvoiceNo = 0;
    this.savedReturnReason = '';
    this.layawayReceiptDropdown = [];
    this.selectedLayawayReceiptId = null;
    this.customerSalesForm.get('invoiceNo').setValue('New');
    this.saleStatus = "New";
    this.menuService.setMenu('1');
  }

  get showCheckoutButton(): boolean {
    const { currentMenu, seqInvoiceNo, pendingSale, hideCheckout } = this;
    var userTerminalSet = this.userTerminal && this.userTerminal != 0;
    const isNotMenu6 = currentMenu !== '6';
    const isEligible = !seqInvoiceNo || pendingSale || currentMenu === '5';

    return isNotMenu6 && isEligible && !hideCheckout && userTerminalSet;
  }

  async cancelSales() {
    // only ask for confirmation when there is something to lose
    if (this.hasSaleInProgress()) {
      const confirm = await Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to cancel?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`
      });
      if (!confirm.value) return;
    }
    this.cancelResetValues();
    this.resetScannerDefaults();
  }

  hasSaleInProgress(): boolean {
    return this.customerItemList?.length > 0
      || !!this.seqInvoiceNo
      || this.pendingSale
      || !!this.customerId
      || this.checkHasAnyItemToAddOrUpdate();
  }

  // restore Barcode Scanner / No Scanner to the defaults configured in POS Settings
  resetScannerDefaults() {
    this.customerSalesForm.get('barcodeScanner').setValue(this.useBarcodeScanner);
    this.customerSalesForm.get('defaultNoScanner').setValue(this.useNoScannerDefault);
  }

  cancelResetValues() {
    this.dispChangePayType = false;
    this.displayChangeCardType = false;
    this.saleStatus = "New";
    this.pendingSale = false;
    this.customerItemList = [];
    this.loadedOrgItemList = [];
    this.isScrapReasonVisible = false;
    this.hideCheckout = false;
    this.vendorDiscountText = '';
    this.noDiscountPlan = false;
    this.resetInvoiceNo();
    this.resetItemData();
    this.editInvoiceOpen = false;
    this.clearForm();
  }

  openDiscountCoupon() {
    const skipUnsavedCheck = this.currentMenu == 'gc' && this.bindNewGCData;
    if (skipUnsavedCheck) {
      this.bindNewGCData = false;
    }
    const hasAnyValue = !skipUnsavedCheck && this.checkHasAnyItemToAddOrUpdate();

    if (hasAnyValue) {
      this.showWarning("Please update or cancel the item and proceed.");
      return;
    }
    if (!this.seqInvoiceNo && this.customerItemList.length > 0) {
      this.openModalById('modalDiscountCoupon');
    } else {
      this.showWarning($localize`Discount Coupon is applicable is only to new invoice..!`);
    }
  }

  // Add Bag is offered on normal sale types for a new invoice or an open pending sale
  get showAddBag(): boolean {
    return this.enableBag
      && ['1', '2', '3', '5', '6'].includes(this.currentMenu)
      && (!this.seqInvoiceNo || this.pendingSale);
  }

  async addBag() {
    if (this.isAddingBag) {
      return;
    }
    if (this.updateExistingItem || this.checkHasAnyItemToAddOrUpdate()) {
      this.showWarning("Please update or cancel the item and proceed.");
      return;
    }
    if (!this.bagMarketVendorId) {
      this.showWarning($localize`Bag Vendor is not configured correctly in POS Settings.`);
      return;
    }

    // POS by booth: the Bag must be sold from a configured booth that the Bag vendor has booked today
    if (!this.allowPossalesWithOutBooking) {
      if (!this.bagBoothNo) {
        this.showWarning($localize`Please assign a Booth to the Bag in POS Settings.`);
        return;
      }
      this.isAddingBag = true;
      try {
        const booking = await lastValueFrom(this.posSalesService.checkBookingForBagVendor().pipe(take(1)));
        if (!booking?.Success) {
          this.showWarning($localize`No Booking exist for this Booth Number!`);
          return;
        }
      } catch {
        this.showWarning($localize`No Booking exist for this Booth Number!`);
        return;
      } finally {
        this.isAddingBag = false;
      }
    }

    // a repeated click adds to the existing Bag line instead of adding a new one
    const index = this.customerItemList.findIndex(x => this.isBagLine(x));
    const qty = index > -1 ? (Number(this.customerItemList[index].ItemQty) || 0) + 1 : 1;
    const totalRate = +(this.bagPrice * qty).toFixed(2);

    const bagLine = {
      ...(index > -1 ? this.customerItemList[index] : {}),
      VendorId: this.bagMarketVendorId,
      BoothId: this.bagBoothNo,
      VendorSeqId: this.bagVendorSeqId,
      StockId: '',
      ItemDescription: 'Bag',
      ItemQty: qty,
      ItemRate: this.fmt(this.bagPrice),
      ItemTotalRate: this.fmt(totalRate),
      ItemDiscValue: 0,
      ItemDiscAmount: this.fmt(0),
      ItemDiscountedPrice: this.fmt(totalRate),
      ItemNetprice: this.fmt(totalRate),
      ItemSalesTax: this.fmt(0),
      ItemSecLvlTax: this.fmt(0),
      VendorName: this.bagVendorName,
      BoothList: this.bagBoothNo,
      ItemCommission: 0,
      Selected: false,
      ItemNoTax: this.currentMenu == '2' ? true : !this.bagTaxable,
      ItemFirm: false,
      StockImageUrl: '',
      InventoryDiscount: null,
      IsBag: true
    };

    if (index > -1) {
      this.customerItemList[index] = bagLine;
    } else {
      this.customerItemList.push(bagLine);
    }

    // recalculates tax/net price for every line using each line's No Tax flag
    this.updateTaxesForAllItems();
  }

  // IsBag is lost when a pending sale is reloaded, so also match on the Bag vendor/description
  isBagLine(item: any): boolean {
    return !!item?.IsBag
      || (!!this.bagVendorSeqId && item?.VendorSeqId == this.bagVendorSeqId
        && !item?.StockId && item?.ItemDescription === 'Bag');
  }

  openInvoiceEmailModel() {
    this.openModalById('modalInvoiceEmail');
  }

  emailInvoiceToCust() {
    if (!this.customerEmailAdd) {
      this.showWarning('Please enter valid email address');
      return false;
    }
    this.printReceipt(false, false, true, 0);
    this.closeModalById('modalInvoiceEmail');
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    document.body.classList.remove('modal-open');

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  getAllCreditCardsByMarket() {
    this.loaderIcon = Promise.resolve(true);
    this.creditCardTypeService.GetAllCreditCardsByMarket()
      .pipe(take(1)).subscribe((res: any) => {
        this.creditCardList = res.filter(el => !el.IsInactive).map((el, i) => ({
          CreditCardTypeId: el.CreditCardTypeId,
          CreditCardTypeDesc: el.CompanyCreditCardTypeDesc,
          ChargeType: el.ChargeType,
          Charge: el.Charge,
          CreditCardType: el.CardType,
          MarketId: el.MarketId
        }));
        this.invoiceChangePaymentForm.get('invsChngPayModifiedCardType').setValue(this.creditCardList[0]?.CreditCardTypeId);
        this.loaderIcon = Promise.resolve(false);
      }, err => {
        this.loaderIcon = Promise.resolve(false);
      });
  }

  openModalById(modalId) {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const modalEl = document.getElementById(modalId)!;
    const hasExistingModal = document.querySelectorAll('.modal.show').length > 0;
    const modal = new bootstrap.Modal(
      modalEl,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    modal.show();
    if (hasExistingModal) {
      modalEl.style.zIndex = '1075';
      setTimeout(() => {
        const backdrops = document.querySelectorAll('.modal-backdrop');
        if (backdrops.length > 0) {
          (backdrops[backdrops.length - 1] as HTMLElement).style.zIndex = '1070';
        }
      }, 0);
    }
  }

  closeModal(modal) {
    if (modal.classList.contains('show')) {
      $(modal).modal('hide');
      setTimeout(() => {
        modal.style.display = 'none';
        modal.classList.remove('show');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
      }, 300);
    }
  }

  getTotalQty(field: keyof typeof this.customerItemList[0]) {
    return this.customerItemList
      .reduce((sum, item) => sum + (Number(item[field]) || 0), 0);
  }

  getTotal(field: keyof typeof this.customerItemList[0]): string {
    const total = this.customerItemList.reduce((sum, item) => {
      if (!item.IsReturnItem) {
        return sum + (Number(this.getActualAmountFromInp(item[field])) || 0);
      }
      return sum;
    }, 0);

    return this.customCurrency.transform(total);
  }

  selectReturnItem(item: any, checked: boolean) {
    const index = this.customerItemList.findIndex(x => x === item);
    if (index === -1) return;

    if (item.IsReturnItem) {
      this.showWarning($localize`Already returned item cannot be selected again.`);
      this.customerItemList[index].Selected = false;
      this.customerItemList = this.customerItemList.map(x =>
        x === item ? { ...x, Selected: false } : x
      );
      return;
    }

    this.customerItemList[index].Selected = checked;

    this.customerSalesForm.get('returnAmount')?.setValue(
      this.getTotalInvoiceAmount()
    );
  }

  getTotalInvoiceAmount(): string {
    const total = this.customerItemList.reduce((sum, item) => {
      if (this.currentMenu == '8' || this.currentMenu == '6' || (this.currentMenu == '7' && item.Selected && !item.IsReturnItem)) {
        const netPrice = Number(this.getActualAmountFromInp(item['ItemNetprice'])) || 0;
        const salesTax = Number(this.getActualAmountFromInp(item['ItemSalesTax'])) || 0;
        const secLvlTax = Number(this.getActualAmountFromInp(item['ItemSecLvlTax'])) || 0;
        if (this.applySalesTaxItemWise)
          return sum + netPrice;
        else
          return sum + salesTax + secLvlTax + netPrice;
      }
      return sum;
    }, 0);

    return this.customCurrency.transform(total)
      || this.customCurrency.transform("0");
  }

  isItemRateEnteredForAdvance = (): boolean => {
    return this.getActualAmountFromInp(this.customerSalesForm.get('itemRate')?.value) > 0;
  }

  getActualAmountFromInp(value: any): number {
    if (value != "") {
      const numericValue = parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
      return value.toString().includes('(') && value.toString().includes(')')
        ? -1 * numericValue
        : numericValue;
    }
  }

  deleteAddedItem(index) {
    this.resetItemData();
    this.clearGeneralFormInfo();
    this.customerItemList.splice(index, 1)
    if (this.currentMenu == '5') {
      this.calculateLayaway();
    }
  }

  resetItemData() {
    this.customerSalesForm.patchValue({
      vendorId: '',
      boothId: '',
      stockId: '',
      itemDescription: '',
      itemQty: '',
      itemRate: '$0.00',
      itemNoTax: false,
      itemDiscType: '2',
      itemDiscValue: '0.0000',
      itemFirm: false,
      gcNo: '',
      gcStartDate: this.minDate,
      gcMaxDays: this.gcMaxDays,
      itemCommission: 0
    }, { emitEvent: false });
    this.rowseqId = 0;
    this.updateExistingItem = false;
    this.addNewItem = true;
    this.showDropdown = false;
    this.vendorDiscountList = [];
    this.inventoryItemDiscount = null;
    this.stockImageUrl = '';
    this.resetItemTaxCheckBox();
    // Vendor is cleared above, so drop the vendor pre-filter on the Stock ID search popup too
    this.inventoryType = 'All';
    this.searchValue = '';
    this.searchField = 6;
  }

  async confirmClearItem() {
    const result = await Swal.fire({
      title: $localize`Confirm`,
      text: $localize`If you continue and click "Yes," the selected item list will be cleared`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    });
    if (result.value) {
      this.resetItemData();
    }
  }

  // Discount plans are percentages; when the type is Amount ($) the user types the amount directly
  isPercentDiscountType(): boolean {
    return this.customerSalesForm.get('itemDiscType')?.value !== '1';
  }

  onDiscountKeydown(event: KeyboardEvent): void {
    if (!this.showDropdown || !this.isPercentDiscountType()) return;

    const options = this.discountOptions;
    const totalOptions = options.length + 1; // +1 for "No discount"

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeIndex = (this.activeIndex + 1) % totalOptions;
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeIndex = (this.activeIndex - 1 + totalOptions) % totalOptions;
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (this.activeIndex >= 0 && this.activeIndex < options.length) {
        this.selectDiscount(options[this.activeIndex]);
      } else if (this.activeIndex === options.length) {
        this.selectDiscount(null); // "No discount"
      }
    }
  }

  selectDiscount(discount: any) {
    if (discount) {
      this.customerSalesForm.patchValue({
        itemDiscValue: discount.DiscountPercent,
        itemDiscType: "2"
      });
    } else {
      this.customerSalesForm.patchValue({
        itemDiscValue: 0,
        itemDiscType: "2"
      });
    }
    this.showDropdown = false;
    this.activeIndex = -1;
  }

  hideDropdownWithDelay() {
    // small delay so mousedown can fire before hiding
    setTimeout(() => this.showDropdown = false, 200);
  }

  onOtherChargeClick() {
    if (this.updateExistingItem) {
      this.showWarning('Please update or delete the item and proceed');
    }
  }

  private showWarning(message: string) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
  }

  private isCustomerIdUnset(value): boolean {
    return value === null || value === undefined || value === '' || Number(value) === 0;
  }

  async validateSubmit() {
    const salesPersonId = this.customerSalesForm.get('salesPersonId').value;
    const returnReason = this.customerSalesForm.get('returnReason').value;
    const returnAmount = this.customerSalesForm.get('returnAmount').value;

    const skipUnsavedCheck = this.currentMenu == 'gc' && this.bindNewGCData;
    const hasAnyValue = !skipUnsavedCheck && this.checkHasAnyItemToAddOrUpdate();

    if (hasAnyValue) {
      if (this.updateExistingItem)
        this.showWarning("Please update item or cancel it before proceeding.");
      else
        this.showWarning("Please add items to grid or cancel it before proceeding.");
      return;
    }

    if (this.trackSalesbyPerson && (!salesPersonId || salesPersonId == '0')) {
      this.showWarning($localize`Please select the sales person.`);
      return false;
    }

    const netPrice = this.getTotal('ItemNetprice');
    if (this.customerItemList.length == 0) {
      this.showWarning($localize`Please add the items for checkout.`);
      return false;
    }

    if (this.getActualAmountFromInp(netPrice) == 0 && (this.currentMenu != '7' && this.currentMenu != '8')) {
      const result = await Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Total Invoice Amount is Zero, this sale cannot be Voided/Returned. Are you sure you want to continue?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`
      });
      if (!result.isConfirmed) return false;
    }

    const mandatoryCustomerMenus = ["2", "3", "5", "gc"];

    if (this.currentMenu === "1" && this.isCustomerIdUnset(this.customerId) && this.isCustomerIdUnset(this.defCustIdForRetail)) {
      this.showWarning($localize`Please select the customer for retail sale.`);
      return false;
    }

    if (mandatoryCustomerMenus.includes(this.currentMenu) && !this.customerId) {
      this.showWarning($localize`Customer information is mandatory.`);
      return false;
    }

    if (this.currentMenu === "6" && !this.customerId && this.custIdReqPendingSale) {
      this.showWarning($localize`Customer information is mandatory.`);
      return false;
    }

    if (this.currentMenu === "2" && !this.customerData?.TaxExemptionNumber) {
      this.showWarning($localize`Wholesaler Id is mandatory for Wholesales. Please update this customer with wholesaler Id else select different customer who has wholesaler Id.`);
      return false;
    }

    if (this.currentMenu == "3" && !this.shipperId) {
      this.showWarning($localize`Shipping information is mandatory.`);
      return false;
    }

    if (this.currentMenu === "7") {
      const selectedCount = this.customerItemList.filter(item => item.Selected).length;

      if (selectedCount === 0) {
        this.showWarning($localize`Please select at least one item to return.`);
        return false;
      }

      if (!returnReason?.trim()) {
        this.showWarning($localize`Please enter the reason for return.`);
        return false;
      }
    }

    if (this.currentMenu == "8" && !returnReason) {
      this.showWarning($localize`Please enter the reason for void.`);
      return false;
    }

    if (this.getActualAmountFromInp(returnAmount) == 0 && (this.currentMenu == '8' || this.currentMenu == '7')) {
      this.showWarning($localize`Since its a 100% discount, it cannot be Voided/Returned.`);
      return false;
    }

    return true;
  }

  clearPaymentPage(val) {
    this.resetPageData();
    this.loadInvoiceList();
    this.getLastInvoiceOfUser();
    this.resetItemData();
    this.setFocusToFirstField();
    this.closePaymentPage(true);
    if (this.currentMenu == 'gc') {
      this.customerSalesForm.get('stockId').setValue(this.gcSaleTerm);
      this.validateStockId();
      this.bindNewGCData = true;
    }
  }

  closePaymentPage(val) {
    this.salesPageVisible = true;
    this.vendorDiscountText = '';

    if (val?.otherCharge !== undefined) {
      this.customerSalesForm.get('otherCharge').setValue(val.otherCharge);
    }

    if (this.currentMenu == 'gc') {
      this.bindNewGCData = true;
    }
    this.getGiftCertificates();
  }

  numberOnly(event): boolean {
    return this.commonCalculatorService.numberOnly(event);
  }

  numberOnlyWithNegative(event): boolean {
    return this.commonCalculatorService.numberOnlyWithNegative(event);
  }

  sanitizeGcNo(event: Event): void {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 16);
    if (input.value !== sanitized) {
      this.customerSalesForm.get('gcNo')?.setValue(sanitized, { emitEvent: false });
      this.customerSalesForm.get('gcNo')?.markAsTouched();
    }
  }

  numberOnlyMaxDecimals(event, maxDecimals: number = 4): boolean {
    const allowed = this.commonCalculatorService.numberOnly(event);
    if (!allowed) return false;
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only control keys (≤31) and decimal point (46); reject everything else (letters, symbols)
    if (charCode < 48 || charCode > 57) return charCode <= 31 || charCode === 46;
    const input: HTMLInputElement = event.target;
    const value = input.value;
    const selStart = input.selectionStart;
    const selEnd = input.selectionEnd;
    const newValue = value.slice(0, selStart) + String.fromCharCode(charCode) + value.slice(selEnd);
    const dotIndex = newValue.indexOf('.');
    if (dotIndex !== -1 && newValue.length - dotIndex - 1 > maxDecimals) {
      return false;
    }
    return true;
  }

  disableCustomerChange() {
    if (!this.pendingSale && this.invoiceNo)
      return true;
    return false;
  }

  async openPaymentPage() {
    const submitValidated = await this.validateSubmit();
    if (!submitValidated)
      return false;

    if (this.currentMenu === '5') {
      var val = this.customerSalesForm.value;

      var layawayData = {
        PaidInstallmentCount: this.paidInstallmentCount,
        DownPayPercent: val.downPaymentPercent,
        DownPayAmount: this.getActualAmountFromInp(val.downPaymentAmt),
        MaxDays: val.downPaymentMaxDays,
        NoOfInstallments: val.installmentNo,
        DueDate: val.downPaymentExpiryDate ? new Date(val.downPaymentExpiryDate) : new Date(),
        LayAccountStatus: 0,
        LayawayPayType: this.invoiceNo && !this.pendingSale ? "LAYINSTLMT" : "LAYDNPAYT",
        LayawayInvoiceDetails: this.layawayInvoiceDetails,
        InstallmentDetails: []
      };

      if (this.installments && this.installments.length > 0) {
        this.installments.forEach((installment, index) => {
          layawayData.InstallmentDetails.push({
            SerialNo: index + 1,
            InstallmentDate: new Date(installment.date),
            InstallmentAmount: this.getActualAmountFromInp(installment.amount)
          });
        });
      }
    }

    let customerIdForSubmit = this.customerId;
    if (!customerIdForSubmit) {
      switch (this.currentMenu) {
        case "1": // Retail
          customerIdForSubmit = this.defCustIdForRetail || 1;
          break;
      }
    }

    this.customerItemList = this.customerItemList.map(e => ({
      ...e,
      BoothId: e.BoothId
        ? e.BoothId
        : (e.BoothList ? e.BoothList.split(',')[0].trim() : '')
    }));

    const data = {
      CustomerDetailsFromgrid: this.customerItemList,
      OtherCharge: this.customerSalesForm.get('otherCharge').value ?? '$0.00',
      SalesTax: this.getTotal('ItemSalesTax'),
      SecondLvlTax: this.getTotal('ItemSecLvlTax'),
      NetPrice: this.getTotal('ItemNetprice'),
      Quantity: this.getTotalQty('ItemQty'),
      DiscountAmount: this.getTotal('ItemDiscAmount'),
      CustomerId: customerIdForSubmit || 1,
      // false when CustomerId is only the default/placeholder customer (nothing selected by the user)
      CustomerSelected: !!this.customerId,
      SalesType: this.currentMenu,
      SalesmanId: this.customerSalesForm.get('salesPersonId').value,
      InvoiceNo: this.seqInvoiceNo,
      ShippingId: this.shipperId,
      Reason: this.customerSalesForm.get('returnReason').value,
      ReturnAmount: this.customerSalesForm.get('returnAmount').value,
      LayawayData: layawayData,
      IsPendingSale: this.pendingSale,
      MarketInvoiceNo: this.invoiceNo,
      CustomerCccharge: this.getActualAmountFromInp(this.customerSalesForm.get('customerCccharge').value)
    }
    this.paymentData = data;
    this.salesPageVisible = false;
    //var url = '/pos/payment';
    //this.router.navigate([url]);
  }

  scrapPendingSale() {
    this.selectedOptionBeforePasscodeAuth = '6';
    const scrapReason = this.customerSalesForm.get('scrapReason').value;
    this.customerSalesForm.get('displayReceipt').setValue(false);
    this.customerSalesForm.get('printReceipt').setValue(false);
    if (this.isScrapReasonVisible && !scrapReason) {
      this.showWarning($localize`Please enter the reason for scrap.`);
      return false;
    }
    this.PassCodeAuthentication.OpenModal();
  }

  async savePendingSale(scrapPendingSale = false) {
    const submitValidated = await this.validateSubmit();
    if (!submitValidated)
      return false;
    this.loaderIcon = Promise.resolve(true);
    if (!this.customerId) {
      this.customerId = this.defCustIdForPendingSale || 1;
    }
    var otherCharge = this.getActualAmountFromInp(this.customerSalesForm.get('otherCharge').value ?? 0);
    var invoiceAmt = this.getTotalInvoiceAmount();
    let salesData = {
      CashAmount: 0,
      ChequeAmount: 0,
      CardAmount: 0,
      BalanceDue: this.getActualAmountFromInp(this.getTotal('ItemNetprice')),
      NetPrice: this.getActualAmountFromInp(this.getTotal('ItemNetprice')),
      OtherCharges: otherCharge,
      AmountPaid: 0,
      InvoiceAmount: this.getActualAmountFromInp(invoiceAmt) + otherCharge,
      CheckNum: "",
      CustomerId: this.customerId || 1,
      SalesType: this.currentMenu,
      SalesmanId: this.customerSalesForm.get('salesPersonId').value,
      OrderId: "",
      CustomerCCCharge: 0,
      POSSalesItemDetails: [],
      InvoiceSeqNo: this.seqInvoiceNo,
      ScrapPendingSale: scrapPendingSale ? this.isScrapReasonVisible : false,
      ScrapReason: scrapPendingSale ? this.customerSalesForm.get('scrapReason').value : ""
    }

    var salesList = this.customerItemList;

    for (const [idx, item] of salesList.entries()) {
      salesData.POSSalesItemDetails.push({
        SerialNumber: idx + 1,
        BoothId: item.BoothId,
        VendorId: item.VendorSeqId || 0,
        StockId: item.StockId,
        ItemDescription: item.ItemDescription,
        Quantity: item.ItemQty,
        Rate: this.getActualAmountFromInp(item.ItemRate),
        DiscountPercent: item.ItemDiscValue,
        DiscountAmount: this.getActualAmountFromInp(item.ItemDiscAmount),
        DiscountedPrice: this.getActualAmountFromInp(item.ItemDiscountedPrice),
        SalesTax: this.getActualAmountFromInp(item.ItemSalesTax),
        SecondLevelTax: this.getActualAmountFromInp(item.ItemSecLvlTax),
        IsReturnItem: false,
        IsConsignItem: false,
        FlatCommissionRate: item.ItemCommission,
        InvoiceItemId: item.InvoiceItemId
      })
    }

    this.posSalesService.savePosItemDetails(salesData)
      .pipe(take(1))
      .subscribe(async res => {
        const settings = this.customerSalesForm.value;
        if (res.Success) {
          if (scrapPendingSale && this.isScrapReasonVisible)
            this.toastr.success($localize`Pending sale scrapped successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          else {
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            if (settings.displayReceipt || settings.printReceipt) {
              this.seqInvoiceNo = res.Id;
              this.printReceipt(settings.displayReceipt, settings.printReceipt, settings.emailReceipt, 0, '6', false, this.seqInvoiceNo);
            }
          }
        } else {
          if (this.isScrapReasonVisible)
            this.toastr.error($localize`Error occured while scrapping the pending sale`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          else
            this.toastr.error($localize`Error occured while saving the transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
        }
        this.resetPageData();
        this.resetInvoiceNo();
        this.getLastInvoiceOfUser();
        this.loadInvoiceList();
        if (!settings.displayReceipt && !settings.printReceipt) {
          this.loaderIcon = Promise.resolve(false);
        }
      }, err => {
        this.loaderIcon = Promise.resolve(false);
      })
  }

  getLastInvoiceOfUser() {
    this.posSalesService.getLastInvoiceOfUser()
      .pipe(take(1)).subscribe(details => {
        this.lastInvoiceofUser = details;
      });
  }

  CustomerInfo(data) {
    this.customerId = data.CustomerId;
    this.existingCustomer = true;
    this.posSalesService.getCustomerDetailsById(this.customerId)
      .pipe(take(1)).subscribe(details => {
        this.customerData = details;
      });
  }

  closeCustomerInfoModal(val) {
    this.customerDataPopup = false;
    const modal = this.customerModal.nativeElement;
    this.closeModal(modal);
  }

  openCustomerForm(formReq) {
    this.customerDataPopup = true;
    this.customerSearch = formReq == "search" ? true : false;
    this.newCustomer = formReq == "new" ? true : false;
  }

  openShipperForm(formReq) {
    this.shipperSearch = formReq == "search" ? true : false;
    this.newShipper = formReq == "new" ? true : false;
  }

  ShipperInfo(data) {
    this.shipperId = data.ShippingId;
    this.existingShipper = true;
    this.posSalesService.getShipperDetailsById(this.shipperId)
      .pipe(take(1)).subscribe(details => {
        this.shipperData = details;
      });
  }

  closeShipperInfoModal(val) {
    const modal = this.shipperModal.nativeElement;
    this.closeModal(modal);
  }

  resetInvoiceFormAndLoad() {
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.invoiceForm.patchValue({
      invoiceNumber: "",
      invoiceFromDate: this.marketDate,
      invoiceToDate: this.marketDate,
      dateFilter: true,
      terminalName: 'ALL',
      invoiceAmount: '',
      saleType: 0,
      firstName: '',
      lastName: '',
      userId: 0
    })
    this.loadInvoiceList();
  }

  loadInvoiceList() {
    const formData = this.invoiceForm.getRawValue();

    // Invoice Amount: blank => not sent; invalid => block search
    const invoiceAmount = this.parseInvoiceAmount(formData.invoiceAmount);
    if (Number.isNaN(invoiceAmount)) {
      this.showWarning($localize`Please enter a valid invoice amount.`);
      return;
    }

    const dateFilterEnabled = formData.dateFilter === true;

    // Validate dates only when date filtering is enabled.
    if (dateFilterEnabled) {
      if (!formData.invoiceFromDate || !formData.invoiceToDate) {
        this.showWarning($localize`Please select both From and To dates.`);
        return;
      }

      const fromDate = new Date(`${formData.invoiceFromDate}T00:00:00`);
      const toDate = new Date(`${formData.invoiceToDate}T00:00:00`);

      if (
        Number.isNaN(fromDate.getTime()) ||
        Number.isNaN(toDate.getTime())
      ) {
        this.showWarning($localize`Please enter valid invoice dates.`);
        return;
      }

      if (fromDate > toDate) {
        this.showWarning(
          $localize`From date cannot be later than To date.`
        );
        return;
      }
    }

    this.invoiceList = [];
    const model = {
      InvoiceNumber: formData.invoiceNumber || 0,
      FromDate: dateFilterEnabled ? formData.invoiceFromDate : null,
      ToDate: dateFilterEnabled ? formData.invoiceToDate : null,
      DateFilter: dateFilterEnabled,
      TerminalName: formData.terminalName == 'ALL' ? "" : formData.terminalName,
      SalesType: formData.saleType,
      FirstName: formData.firstName,
      LastName: formData.lastName,
      UserId: formData.userId,
      InvoiceAmount: invoiceAmount
    }
    this.posSalesService.getInvoiceList(model)
      .pipe(take(1)).subscribe(details => {
        this.invoiceList = details.map((item: any) => ({
          ...item,
          InvoiceDate: this.datePipe.transform(item.InvoiceDate, 'MM/dd/yyyy'), // format here
          PendingSaleData: item.MarketInvoiceNo + " - " + item.InvoiceCreatedTime
        }));
        this.recentPendingSaleList = this.invoiceList.filter(e => {
          const today = this.marketDate;
          return e.SalesType == 6 &&
            this.datePipe.transform(e.InvoiceDate, 'yyyy-MM-dd') === today;
        });
      });
  }

  // Returns null when blank, NaN when invalid, otherwise the numeric amount
  private parseInvoiceAmount(value: any): number | null {
    const raw = (value ?? '').toString().replace(/[$,\s]/g, '');
    if (raw === '') return null;
    if (!/^\d+(\.\d{1,2})?$/.test(raw)) return NaN;
    return parseFloat(raw);
  }

  // Show plain digits while editing (e.g. "$49.39" -> "49.39")
  onInvoiceAmountFocus() {
    const ctrl = this.invoiceForm.get('invoiceAmount');
    const raw = (ctrl?.value ?? '').toString().replace(/[$,\s]/g, '');
    if (raw !== (ctrl?.value ?? '')) ctrl?.setValue(raw, { emitEvent: false });
  }

  // Format as currency on leaving the field; leave invalid text untouched so OK is blocked
  onInvoiceAmountBlur() {
    const ctrl = this.invoiceForm.get('invoiceAmount');
    const amount = this.parseInvoiceAmount(ctrl?.value);
    if (amount === null || Number.isNaN(amount)) return;
    ctrl?.setValue(this.customCurrency.transform(amount.toString()), { emitEvent: false });
  }

  loadPendingSale() {
    var selectedInvoiceNo = this.customerSalesForm.get('selectedPendingSale').value;
    const data = this.invoiceList.find(e => e.SeqInvoiceNo == selectedInvoiceNo);
    this.loadInvoiceItemDetails(data);
  }

  onInvoiceSearch() {
    if (this.isInvoiceLoading) {
      return;
    }

    const marketInvoiceNo = this.customerSalesForm.get('invoiceNo')?.value;

    if (marketInvoiceNo && marketInvoiceNo !== 'New') {
      this.isInvoiceLoading = true;

      this.posSalesService.getInvoiceSummaryById(marketInvoiceNo)
        .pipe(take(1))
        .subscribe({
          next: (details) => {
            if (details.SeqInvoiceNo === 0) {
              this.showWarning(`Sorry, No invoice found with this invoice #`);
              this.cancelResetValues();
            } else {
              this.loadInvoiceItemDetails(details);
            }
          },
          error: () => {
            this.showWarning('Something went wrong while fetching invoice details');
          },
          complete: () => {
            this.isInvoiceLoading = false;
          }
        });
    }
  }

  onInvoiceRowSelected(args: any) {
    this.selectedInvoiceRow = args.data;
  }

  onInvoiceDoubleClick(args: any) {
    if (!args || !args.rowData) {
      return;
    }

    const rowData = args.rowData;
    this.loadInvoiceItemDetails(rowData);
  }

  selectedInvoiceData() {
    this.loadInvoiceItemDetails(this.selectedInvoiceRow);
  }

  closeInvoiceListModal() {
    this.selectedInvoiceRow = "";
    this.closeModalById('invoiceModal');
  }

  loadInvoiceItemDetails(data) {
    this.currentInvoiceData = data;
    this.selectedInvoiceRow = "";
    this.cancelLayawaySaleClicked = false;
    this.loaderIcon = Promise.resolve(true);
    this.hideVoidButton = false;
    this.invoiceNo = data?.MarketInvoiceNo;
    this.pendingSale = data?.SalesType == 6;
    this.saleStatus = "";
    this.layawayReceiptDropdown = [];
    this.selectedLayawayReceiptId = null;
    this.customerItemList = [];
    this.loadedOrgItemList = [];
    this.dispChangePayType = data?.SalesType == 1 || data?.SalesType == 2 || data?.SalesType == 3;
    this.customerSalesForm.patchValue({
      invoiceNo: data?.MarketInvoiceNo,
      salesPersonId: data?.SalesmanId
    });
    this.seqInvoiceNo = data?.SeqInvoiceNo;
    this.hideCheckout = false;
    this.posSalesService.getInvoiceItemsList(data?.SeqInvoiceNo)
      .pipe(take(1)).subscribe(res => {
        if (res && res.POSSalesItemDetails.length != 0) {
          const fmt = (num: number) => num != null ? this.customCurrency.transform(num.toString()) : '';

          for (let item of res.POSSalesItemDetails) {
            const baseItem = {
              InvoiceItemId: item.InvoiceItemId,
              VendorId: item.MarketVendorId,
              BoothId: item.BoothId,
              StockId: item.StockId,
              VendorName: this.vendorName,
              BoothList: this.boothList,
              VendorSeqId: item.VendorId,
              SaleType: data?.InvoiceSaleTypeId,
              InvoiceDate: data?.InvoiceDate,
              Selected: false,
              IsReturnItem: item.IsReturnItem,
              SerialNumber: item.SerialNumber,
              FlatCommissionRate: item.FlatCommissionRate
            };

            this.customerItemList.push({
              ...baseItem,
              ItemDescription: item.ItemDescription,
              ItemQty: item.Quantity,
              ItemRate: fmt(item.Rate),
              ItemTotalRate: fmt(item.Quantity * item.Rate),
              ItemDiscValue: item.DiscountPercent,
              ItemDiscAmount: fmt(item.DiscountAmount),
              ItemDiscountedPrice: fmt(item.DiscountedPrice),
              ItemNetprice: this.applySalesTaxItemWise ? fmt(item.DiscountedPrice + item.SalesTax + item.SecondLevelTax) : fmt(item.DiscountedPrice),
              ItemSalesTax: fmt(item.SalesTax),
              ItemSecLvlTax: fmt(item.SecondLevelTax),
              TaxNotApplied: (item.SalesTax + item.SecondLevelTax) > 0 ? false : true,
              ItemCommission: item.FlatCommissionRate,
              ItemNoTax: this.applySalesTax || this.applySecLvlTax ? ((item.SalesTax + item.SecondLevelTax) == 0 ? true : false) : false
            });

            if (item.IsReturnItem) {
              var voidReturnText = data?.SalesType?.toString() == '8' ? 'Voided' : 'Returned'
              // Row 1: Return Item Description
              this.customerItemList.push({
                ...baseItem,
                ItemDescription: `${voidReturnText} ${item.ItemDescription} on ${this.datePipe.transform(item.LastUpdatedDate, "MM/dd/yyyy")}`,
                ItemQty: "",
                ItemRate: "",
                ItemTotalRate: "",
                ItemDiscValue: "",
                ItemDiscAmount: "",
                ItemDiscountedPrice: "",
                ItemNetprice: fmt((item.DiscountedPrice) * (-1)),
                ItemSalesTax: "",
                ItemSecLvlTax: "",
                IsReturnItem: true
              });

              // Row 2: Returned Sales Tax (if exists)
              if (item.SalesTax > 0) {
                this.customerItemList.push({
                  ...baseItem,
                  ItemDescription: `${voidReturnText} Sales Tax on ${this.datePipe.transform(item.LastUpdatedDate, "MM/dd/yyyy")}`,
                  ItemQty: "",
                  ItemRate: "",
                  ItemTotalRate: "",
                  ItemDiscValue: "",
                  ItemDiscAmount: "",
                  ItemDiscountedPrice: "",
                  ItemNetprice: fmt(item.SalesTax * (-1)),
                  ItemSalesTax: "",
                  ItemSecLvlTax: "",
                  IsReturnItem: true
                });
              }

              // Row 3: Returned Second Level Tax (if exists)
              if (item.SecondLevelTax > 0) {
                this.customerItemList.push({
                  ...baseItem,
                  ItemDescription: `${voidReturnText} ${this.secondLevelTaxName} on ${this.datePipe.transform(item.LastUpdatedDate, "MM/dd/yyyy")}`,
                  ItemQty: "",
                  ItemRate: "",
                  ItemTotalRate: "",
                  ItemDiscValue: "",
                  ItemDiscAmount: "",
                  ItemDiscountedPrice: "",
                  ItemNetprice: fmt(item.SecondLevelTax * (-1)),
                  ItemSalesTax: "",
                  ItemSecLvlTax: "",
                  IsReturnItem: true
                });
              }
            }
          }

          this.loadedOrgItemList = this.customerItemList;

          if (this.paymentGatewayCredentials && this.processCreditCardOnline && res.PaymentDetails?.CCAmountPaid > 0) {
            this.dispChangePayType = false;
          }

          const modal = this.invoiceModal.nativeElement;
          this.closeModal(modal);

          if (data.CustomerId) {
            this.CustomerInfo(data);
          }
          if (data.ShippingId) {
            this.ShipperInfo(data);
          }
          this.currentMenu = data.SalesType.toString();
          this.isScrapReasonVisible = this.currentMenu == '6' ? true : false;
          this.customerSalesForm.get('customerCccharge').setValue(this.customCurrency.transform(res.CustomerCccharge));
          if (this.currentMenu == '5') {
            this.paidInstallmentCount = 0;
            this.layawayInvoiceDetails = res.LayawaySalesInvoiceDetails
            const layawayAmountPaidDetails = this.layawayInvoiceDetails?.LayawayAmountPaidDetails ?? [];
            this.layawayReceiptDropdown = [...layawayAmountPaidDetails]
              .filter(e => e?.SalesRectId != null)
              .sort((a, b) => (a.SalesRectId ?? 0) - (b.SalesRectId ?? 0))
              .map(e => ({
                SalesRectId: e.SalesRectId,
                ReceiptType: e.ReceiptType
              }));
            this.selectedLayawayReceiptId = this.layawayReceiptDropdown[0]?.SalesRectId ?? null;
            this.currentSalesReceiptId = this.selectedLayawayReceiptId ?? 0;
            const paidInstallment = layawayAmountPaidDetails.filter(e => e.ReceiptType == "LAYINSTLMT")?.length;
            this.paidInstallmentCount = paidInstallment;
            this.customerSalesForm.get('downPaymentPercent')?.setValue(res?.LayawaySalesInvoiceDetails?.DownPaymentPercent);
            this.customerSalesForm.get('downPaymentMaxDays')?.setValue(res?.LayawaySalesInvoiceDetails?.MaxDays);
            this.customerSalesForm.get('installmentNo')?.setValue(res?.LayawaySalesInvoiceDetails?.NoOfInstallment);
            this.calculateLayaway();
            if ((this.layawayInvoiceDetails?.NetPrice - this.layawayInvoiceDetails.TotalAmountPaid <= 0) || this.layawayInvoiceDetails.LayawayAccountStatus == true) {
              this.hideCheckout = true;
            }
            this.saleStatus = this.layawayInvoiceDetails.LayawayAccountStatus == true ? "Closed" : "Open";
          } else {
            this.saleStatus = (() => {
              switch (data?.SalesType?.toString()) {
                case '8': return "Void Sale";
                case '7': return "Return Sale";
                default: return "";
              }
            })();
          }

          this.customerSalesForm.get('otherCharge').setValue(this.customCurrency.transform(res.OtherCharge));
          this.hideVoidButton = data.SalesType.toString() == '8' ? true : false;
          this.menuService.setMenu(this.currentMenu);
          this.savedReturnReason = res?.Reason?.trim() ? res.Reason : '';
          this.customerSalesForm.get('returnReason').setValue(res?.Reason);

          this.displayChangeCardType = false;
          this.posSalesService.getInvoicePaymentDetails(this.seqInvoiceNo)
            .pipe(take(1))
            .subscribe(res => {
              if (res) {
                if (!this.chargeCCProcessingFee && res.CCAmountPaid > 0 && (data.SalesType == 1 || data.SalesType == 2 || data.SalesType == 3)) {
                  this.displayChangeCardType = true;
                  this.changeCardTypeForm.patchValue({
                    changeCardTypeInvoice: this.invoiceNo,
                    changeCardTypeCCAmt: res.CCAmountPaid,
                    changeCardTypeCurrentCard: res.CardType
                  })
                }
              }
            });
        }
        this.loaderIcon = Promise.resolve(false);
      }, err => {
        this.loaderIcon = Promise.resolve(false);
      });
  }

  saveChangeCardType() {
    const newCardType = this.changeCardTypeForm?.get('changeCardTypeNewCard')?.value;

    if (!newCardType || newCardType == "") {
      this.showWarning('Please select a card type');
      return;
    }

    this.posSalesService
      .updateInvoiceCardType(this.seqInvoiceNo, newCardType)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          if (res?.Success) {
            this.toastr.success($localize`Card type changed successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            this.closeModalById('changeCardType');
          } else {
            this.toastr.error(res?.Message || $localize`Unable to change card type`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          }
        },
        error: () => {
          this.toastr.error($localize`Something went wrong while changing the card type`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
        }
      });
  }

  viewChangeCardTye() {
    this.openModalById('changeCardType');
  }

  viewPaymentDataForm() {
    this.getInvoicePaymentDetails();
    this.openModalById('viewPaymentData');
  }

  async changePaymentDataForm() {
    const res = await lastValueFrom(this.dayEndService.CheckDayEndProcessForInvoice(this.seqInvoiceNo).pipe(take(1)));
    if (res !== null && res.Status) {
      this.showWarning($localize`Cannot change the payment type. Day end is already processed for the selected invoice.`);
      return;
    }
    this.getInvoicePaymentDetails();
    this.openModalById('changePaymentType');
  }

  getInvoicePaymentDetails() {
    this.posSalesService.getInvoicePaymentDetails(this.seqInvoiceNo)
      .pipe(take(1))
      .subscribe(res => {

        const cash = res?.CashAmountPaid ?? 0;
        const cheque = res?.CheckAmountPaid ?? 0;
        const cc = res?.CCAmountPaid ?? 0;
        const traveler = res?.TravelerCheckAmountPaid ?? 0;

        // Patch initial values
        this.invoicePayDataForm.patchValue({
          invNetPrice: this.customCurrency.transform(res?.NetPrice),
          invoiceTotAmt: this.customCurrency.transform(res?.TotalInvoiceAmount),
          invCashPaid: this.customCurrency.transform(cash),
          invCheckPaid: this.customCurrency.transform(cheque),
          invCheckNo: res?.CheckNo,
          invCCPaid: this.customCurrency.transform(cc),
          invTravelerCheckPaid: this.customCurrency.transform(traveler),
          invTravelerCheckNo: res?.TravelerCheckNo,
          invOtherCharge: this.customCurrency.transform(res?.OtherCharge),
          invSalesTax: this.customCurrency.transform(res?.SalesTax),
          invSecLvlTax: this.customCurrency.transform(res?.SeclevelTax),
          invBalanceDue: this.customCurrency.transform(res?.BalanceDue),
          invCCCharges: this.customCurrency.transform(res?.CCCharge),
          invCardType: res?.CardType
        });

        this.invoiceChangePaymentForm.patchValue({
          invsChngPayCashPaid: this.customCurrency.transform(cash),
          invsChngPayCheckPaid: this.customCurrency.transform(cheque),
          invsChngPayCheckNo: res?.CheckNo,
          invsChngPayCCPaid: this.customCurrency.transform(cc),
          invsChngPayTravCheckPaid: this.customCurrency.transform(traveler),
          invsChngPayTravCheckNo: res?.TravelerCheckNo,
          invsChngPayModifiedCardType: res?.CardTypeId
        })
      })
  }

  checkPaymentType() {
    const cardTypeId = this.invoiceChangePaymentForm.get('invsChngPayModifiedCardType')?.value;
    const cardType = this.creditCardList.find(e => e.CreditCardTypeId === cardTypeId)?.ChargeType;
    this.transactionType = cardType?.toLowerCase() === 'credit card' ? 'CREDITSALE' : 'DEBITSALE';

    this.calculateCardFees();
  }

  calculateCardFees() {
    if (this.chargeCCProcessingFee) {
      var convenienceFee = 0;
      var card = this.getActualAmountFromInp(this.inputtedCCAmt || 0);
      const cardIdSelected = this.invoiceChangePaymentForm.get('invsChngPayModifiedCardType').value;
      var creditcardData = this.creditCardList.filter(e => e.CreditCardTypeId == cardIdSelected);
      if (creditcardData) {
        if (card > 0) {
          if (creditcardData[0].ChargeType.includes("Percentage")) {
            var convenienceFee = parseFloat((card * ((creditcardData[0].Charge) / 100)).toFixed(2));
          }
          else {
            convenienceFee = creditcardData[0].Charge ?? 0;
          }
        }
      }
      convenienceFee = parseFloat(convenienceFee.toFixed(2))
      var totalModifiedCC = convenienceFee + parseFloat(this.inputtedCCAmt);
      this.invoiceChangePaymentForm.get('invsChngPayModifiedCC').setValue(this.customCurrency.transform(totalModifiedCC.toString()));
    }
  }

  saveChangePaymentType() {
    const form = this.invoiceChangePaymentForm;

    const invoiceTotal =
      this.getActualAmountFromInp(
        this.invoicePayDataForm.get('invoiceTotAmt')?.value
      ) || 0;

    const modifiedTotal =
      this.getActualAmountFromInp(
        form.get('invsChngPayModifiedTotalPaid')?.value
      ) || 0;

    const modifiedCC =
      this.getActualAmountFromInp(
        form.get('invsChngPayModifiedCC')?.value
      ) || 0;

    const existingCC =
      this.getActualAmountFromInp(
        form.get('invsChngPayCCPaid')?.value
      ) || 0;

    const checkAmount =
      this.getActualAmountFromInp(
        form.get('invsChngPayModifiedCheck')?.value
      ) || 0;

    const checkNo = form.get('invsChngPayModifiedCheckNo')?.value;

    const travCheckAmount =
      this.getActualAmountFromInp(
        form.get('invsChngPayModifiedTravCheck')?.value
      ) || 0;

    const travCheckNo = form.get('invsChngPayModifiedTravCheckNo')?.value;

    if (modifiedTotal != invoiceTotal) {
      this.showWarning('Please enter the correct invoice amount');
      return;
    }

    if (checkAmount > 0 && (!checkNo || checkNo.trim() === '')) {
      this.showWarning('Please enter check number.');
      return;
    }
    if (travCheckAmount > 0 && (!travCheckNo || travCheckNo.trim() === '')) {
      this.showWarning('Please enter Traveler check number.');
      return;
    }

    // if(modifiedCC != existingCC && ) 
    if (modifiedCC > 0 && this.paymentGatewayCredentials && this.processCreditCardOnline) {
      this.processPayment = true;
    } else {
      const response = {
        PaymentSuccess: true,
        OrderId: "",
        VerifoneId: 0
      };
      this.paymentResponse(response);
    }
  }

  enteredCCModifiedAmount() {
    this.inputtedCCAmt = this.invoiceChangePaymentForm.get('invsChngPayModifiedCC').value;
  }

  clearChangePayTypeForm() {
    this.invoiceChangePaymentForm.patchValue({
      invsChngPayModifiedCash: '$0.00',
      invsChngPayModifiedCheck: '$0.00',
      invsChngPayModifiedCheckNo: '',
      invsChngPayModifiedCC: '$0.00',
      invsChngPayModifiedTravCheck: '$0.00',
      invsChngPayModifiedTravCheckNo: ''
    })
  }

  applyCurrency(ctrl) {
    //const ctrl = this.invoiceChangePaymentForm.get(controlName);
    if (!ctrl || ctrl.value === null || ctrl.value === '') return;

    const value = ctrl.value;
    ctrl.setValue(this.customCurrency.transform(value), { emitEvent: false });

    this.invoiceChangePaymentForm.get('invsChngPayModifiedCardType').disable();
    if (this.getActualAmountFromInp(this.invoiceChangePaymentForm.get('invsChngPayModifiedCC').value) > 0)
      this.invoiceChangePaymentForm.get('invsChngPayModifiedCardType').enable();
    this.calculateCardFees();
  }

  calculateTotalPaid() {
    const cash = this.getActualAmountFromInp(this.invoiceChangePaymentForm.get('invsChngPayModifiedCash')?.value) || 0;
    const check = this.getActualAmountFromInp(this.invoiceChangePaymentForm.get('invsChngPayModifiedCheck')?.value) || 0;
    const card = this.getActualAmountFromInp(this.invoiceChangePaymentForm.get('invsChngPayModifiedCC')?.value) || 0;
    const traveler = this.getActualAmountFromInp(this.invoiceChangePaymentForm.get('invsChngPayModifiedTravCheck')?.value) || 0;
    const total = this.customCurrency.transform((cash + check + card + traveler).toString());

    this.invoiceChangePaymentForm.get('invsChngPayModifiedTotalPaid')?.setValue(total, { emitEvent: false });
  }

  ClosePaymentPage() {
    this.processPayment = false;
    this.voidPayment = false;
  }

  paymentResponse(response) {
    this.loaderIcon = Promise.resolve(true);
    if (response.PaymentSuccess) {
      var form = this.invoiceChangePaymentForm;
      var modifiedCC = this.getActualAmountFromInp(form.get('invsChngPayModifiedCC')?.value) || 0;
      var ccCharge = modifiedCC - this.getActualAmountFromInp(this.inputtedCCAmt ?? 0);
      this.processPayment = false;
      // this.verifoneId = response.VerifoneId;

      var obj = {
        InvoiceNo: this.seqInvoiceNo,
        CashAmount: this.getActualAmountFromInp(form.get('invsChngPayModifiedCash')?.value) || 0,
        CheckAmount: this.getActualAmountFromInp(form.get('invsChngPayModifiedCheck')?.value) || 0,
        CheckNo: form.get('invsChngPayModifiedCheckNo')?.value,
        CCAmount: modifiedCC,
        CCChargeFee: ccCharge,
        TravelerCheckAmount: this.getActualAmountFromInp(form.get('invsChngPayModifiedTravCheck')?.value) || 0,
        TravelerCheckNo: form.get('invsChngPayModifiedTravCheckNo')?.value
      }
      this.posSalesService.updateInvoicePaymentType(obj)
        .pipe(take(1)).subscribe(res => {
          if (res.Success) {
            this.toastr.success($localize`Payment type successfully changed`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          } else {
            this.toastr.error($localize`Error occured while changing payment type`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          }
          this.closeModalById('changePaymentType');
          this.clearChangePayTypeForm();
          this.loaderIcon = Promise.resolve(false);
        });
    }
  }

  changeCustomerOrStock() {
    const selectedValue = this.invoiceEditForm.get('editCustomerOrStock')?.value;
    this.invoiceEditForm.get('newComm')?.disable();
    this.invoiceEditForm.get('newComm')?.setValue(0);
    if (selectedValue === "customer") {
      this.invoiceEditForm.get('newVendorId')?.enable();
      this.invoiceEditForm.get('newBoothId')?.disable();
      this.invoiceEditForm.get('newStockId')?.disable();
      this.invoiceEditForm.get('newItemDescription')?.enable();
      this.invoiceEditForm.get('changeReason')?.enable();

      this.invoiceEditForm.get('newBoothId')?.setValue('');
      this.invoiceEditForm.get('newStockId')?.setValue('');
    }
    else if (selectedValue === "boothId") {
      this.invoiceEditForm.get('newVendorId')?.disable();
      this.invoiceEditForm.get('newStockId')?.disable();
      this.invoiceEditForm.get('newBoothId')?.enable();
      this.invoiceEditForm.get('newItemDescription')?.enable();
      this.invoiceEditForm.get('changeReason')?.enable();

      this.invoiceEditForm.get('newVendorId')?.setValue('');
      this.invoiceEditForm.get('newStockId')?.setValue('');
    }
    else if (selectedValue === "stock") {
      this.invoiceEditForm.get('newVendorId')?.disable();
      this.invoiceEditForm.get('newBoothId')?.disable();
      this.invoiceEditForm.get('newItemDescription')?.enable();
      this.invoiceEditForm.get('changeReason')?.enable();
      this.invoiceEditForm.get('newStockId')?.enable();
      this.invoiceEditForm.get('newVendorId')?.setValue('');
      this.invoiceEditForm.get('newBoothId')?.setValue('');
    }
    this.allowCommissionOverride ? this.invoiceEditForm.get('newComm')?.enable() : this.invoiceEditForm.get('newComm')?.disable();
    this.invoiceEditForm.get('newItemDescription').setValue(this.invoiceEditForm.get('existingItemDescription').value)
  }

  updateInvoiceItemDetails() {
    const invoiceEditData = this.invoiceEditForm.value;
    const selectedValue = this.invoiceEditForm.get('editCustomerOrStock')?.value;
    if (selectedValue === "customer" && !invoiceEditData.newVendorSeqId) {
      this.showWarning(this.wordReplacePipe.transform(`Please select the new Vendor Id`))
      return false;
    }
    if (selectedValue === "boothId" && !invoiceEditData.newBoothId) {
      this.showWarning(`Please select the new Booth Id`)
      return false;
    }
    if (selectedValue === "stock" && !invoiceEditData.newStockId) {
      this.showWarning(`Please select the new Stock Id`)
      return false;
    }

    if (!invoiceEditData.newItemDescription?.trim()) {
      this.showWarning(`Please enter the modified Item description`)
      return false;
    }

    if (!invoiceEditData.changeReason) {
      this.showWarning(`Please enter the reason for change`)
      return false;
    }

    var details = {
      InvoiceNumber: this.seqInvoiceNo,
      OriginalvendorId: this.invoiceEditForm.get('existingVendorSeqId').value,
      ItemSerialNumber: invoiceEditData.ItemSerialNumber,
      NewVendorId: invoiceEditData.newVendorSeqId ? invoiceEditData.newVendorSeqId : this.invoiceEditForm.get('existingVendorSeqId').value,
      NewStockId: invoiceEditData.newStockId ? invoiceEditData.newStockId : this.invoiceEditForm.get('existingStockId').value,
      BoothId: invoiceEditData.newBoothId ? invoiceEditData.newBoothId : this.invoiceEditForm.get('existingBoothId').value,
      Commision: this.invoiceEditForm.get('newComm').value,
      OriginalItemDescription: this.invoiceEditForm.get('existingItemDescription').value,
      NewItemDescription: invoiceEditData.newItemDescription,
      InvoiceItemId: invoiceEditData.invoiceItemId,
      ReasaonForChange: invoiceEditData.changeReason
    }

    this.posSalesService.updateInvoiceDetails(details)
      .pipe(take(1)).subscribe(res => {
        if (res.Success)
          this.toastr.success($localize`Invoice updated successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        const data = this.invoiceList.find(e => e.SeqInvoiceNo == this.seqInvoiceNo);
        const invoiceData = data || this.currentInvoiceData;
        this.loadInvoiceItemDetails(invoiceData);
        this.invoiceEditForm.reset();
        this.invoiceEditForm.get('editCustomerOrStock')?.setValue(this.posTransactionByVendor ? 'customer' : 'boothId');
        this.changeCustomerOrStock();
        const modal = this.invoiceEditModal.nativeElement;
        this.closeModal(modal);
        this.resetItemData();
      });
  }

  async getVendorByIdOfExistingInvoice() {
    const invoiceEditData = this.invoiceEditForm.value;
    var vendorId = invoiceEditData.newVendorId ? invoiceEditData.newVendorId : this.invoiceEditForm.get('existingVendorId').value;
    if (!this.posTransactionByVendor) {
      const boothId = invoiceEditData.newBoothId ? invoiceEditData.newBoothId : invoiceEditData.existingBoothId;
      var res = await lastValueFrom(this.vendorService.getVendorIdbyBoothNoForCurrentDay(boothId).pipe(take(1)));
      if (res) {
        vendorId = res.MarketVendorId;
      }
    }
    this.getPOSVendorActiveDiscountPlan(false);
    this.getVendorInfoByMarketVendorId(vendorId);
  }

  setVendorValue() {
    this.showVendorSearch = true;
  }

  onVendorModalClose() {
    this.closeModalById('vendorModal');
    if (!this.allowPossalesWithOutBooking) {
      this.posVendorSearch.resetSearchFields();
    } else {
      this.vendorSearch.resetSearchFields();
      this.showVendorSearch = false;
    }
  }

  async getPOSPrinterSettings(saleTypeId) {
    this.loaderIcon = Promise.resolve(true);
    var res = await lastValueFrom(this.printerService.getPOSPrinterSettings().pipe(take(1)));
    if (res) {
      switch (saleTypeId) {
        case '1':
          this.printThermalReceipt = res.RetailThermal;
          this.thermalReceiptCopies = res.RetailCopies;
          break;
        case '2':
          this.printThermalReceipt = res.WholesaleThermal;
          this.thermalReceiptCopies = res.WholesaleCopies;
          break;
        case '3':
          this.printThermalReceipt = res.OnlineSaleThermal;
          this.thermalReceiptCopies = res.OnlineSaleCopies;
          break;
        case '5':
          if (this.paymentData?.LayawayData?.LayawayPayType == "LAYDNPAYT") {
            this.printThermalReceipt = res.LayawayDownPaymentThermal;
            this.thermalReceiptCopies = res.LayawayDownPaymentCopies;
            break;
          }
          else if (this.paymentData?.LayawayData?.LayawayPayType == "LAYINSTLMT") {
            this.printThermalReceipt = res.LayawayInstallmentThermal;
            this.thermalReceiptCopies = res.LayawayInstallmentCopies;
            break;
          }
        case '6':
          this.printThermalReceipt = res.PendingSaleThermal;
          this.thermalReceiptCopies = res.PendingSaleCopies;
          break;
        case '7':
          this.printThermalReceipt = res.ReturnSaleThermal;
          this.thermalReceiptCopies = res.ReturnSaleCopies;
          break;
        case '8':
          this.printThermalReceipt = res.VoidSaleThermal;
          this.thermalReceiptCopies = res.VoidSaleCopies;
          break;
        case 'GC':
          this.printThermalReceipt = res.GcThermal;
          this.thermalReceiptCopies = res.GcCopies;
          break;
      }

      this.posMerchantCopy = res.PosMerchantCopy;
      this.posMerchantCopies = res.PosMerchantCopies;
      this.posCustomerCopy = res.PosCustomerCopy;
      this.posCustomerCopies = res.PosCustomerCopies;
      this.loaderIcon = Promise.resolve(false);
    }
  }

  openLayawayInfo(data) {
    if (data.SalesType != 5) {
      this.showWarning(`Not a layaway sale.`);
      return false;
    }
    this.seqInvoiceNo = data.SeqInvoiceNo;
    this.printReceipt(true, false, false, 0, '5', true)
  }

  private getSaleTypeAttachmentPrefix(): string {
    switch (this.currentMenu) {
      case '1':
        return 'RetailSale';
      case '2':
        return 'WholesaleSale';
      case '3':
        return 'OnlineSale';
      case '5':
        return 'LayawaySale';
      case '6':
        return 'PendingSale';
      case '7':
        return 'ReturnSale';
      case '8':
        return 'VoidSale';
      default:
        return 'Sale';
    }
  }

  async printReceipt(display, print, email, receiptId, saleTypeId = '', layawayPreview = false, seqInvsNo = 0, itemReturnId: number = null) {
    saleTypeId = saleTypeId == '' ? this.currentMenu : saleTypeId;
    var invsNum = seqInvsNo == 0 ? this.seqInvoiceNo : seqInvsNo;
    this.loaderIcon = Promise.resolve(true);
    await this.getPOSPrinterSettings(saleTypeId);
    const selectedReceiptId = receiptId || this.selectedLayawayReceiptId || this.layawayReceiptDropdown[0]?.SalesRectId || 0;
    // var cardAmount = this.getActualAmountFromInp(this.paymentForm.get('creditCardAmount').value);
    var cardAmount = 0;
    const generateAndProcessPDF = (
      type: 'Receipt',
      display: boolean,
      print: boolean,
      email: boolean,
      baseTemplateId: number,
      emailSubject: string
    ) => {
      const params = {
        InvsNumber: invsNum,
        SalesReceiptid: selectedReceiptId,
        layawayPreview: layawayPreview,
        ItemReturnId: itemReturnId
      };
      this.posSalesService.generatePOSReceipt(params).pipe(take(1)).subscribe((res: any) => {
        if (!res.Success) return;
        const message = res.Message;
        this.loaderIcon = Promise.resolve(false);
        if (!message || !message.startsWith('data:application/pdf;base64,')) {
          Swal.fire('Error', `Invalid ${type} PDF data in response`, 'error');
          return;
        }

        // --- DISPLAY PDF IN MODAL ---
        if (display) {
          this.showPDFModal(message);
        }

        // --- EMAIL PDF ---
        if (email) {
          this.sendEmail(
            0,
            5,
            message,
            `${this.getSaleTypeAttachmentPrefix()}_${type}`,
            emailSubject,
            invsNum,
            this.customerEmailAdd
          );
        }

        // --- PRINT PDF ---
        if (print && !this.printThermalReceipt) {
          printJS({
            printable: message.split(',')[1],
            type: 'pdf',
            base64: true,
            onPrintDialogClose: () => {
            },
          });
        } else if (print && this.printThermalReceipt) {
          launchThermalPrint();
        }
      }
      );
    };

    // Thermal receipts are rendered by the silentprinter desktop app, not from the server PDF
    const launchThermalPrint = () => {
      var customProtocolUrl;
      if (this.currentMenu == '5') {
        if (cardAmount > 0) {
          customProtocolUrl = 'silentprinter://?methodname=layawaypaymentreceipt&param1=' + invsNum + '&param2=' + this.thermalReceiptCopies + '&param3=' + selectedReceiptId + '&uniqueSessionId=' + this.uniqueSessionId + '&MerchantCopy=' + (this.posMerchantCopy ?? false) + '&CustomerCopy=' + (this.posCustomerCopy ?? false) + '&MerchantNoOfCopies=' + (this.posMerchantCopies ?? 0) + '&CustomerNoOfCopies=' + (this.posCustomerCopies ?? 0) + '&ReceiptHead=true';
        } else {
          customProtocolUrl = 'silentprinter://?methodname=layawaypaymentreceipt&param1=' + invsNum + '&param2=' + this.thermalReceiptCopies + '&param3=' + selectedReceiptId + '&uniqueSessionId=' + this.uniqueSessionId + '&ReceiptHead=true';
        }
        window.location.href = customProtocolUrl;
      } else {
        const methodName =
          this.currentMenu === "7" ? "returnsalereceipt" :
            this.currentMenu === "8" ? "posvoidreceipt" :
              "pospaymentreceipt";

        const param1 = invsNum ?? "";
        const param2 = this.thermalReceiptCopies ?? 1;
        const session = this.uniqueSessionId ?? "";
        const mCopy = this.posMerchantCopy ?? false;
        const cCopy = this.posCustomerCopy ?? false;
        const mNo = this.posMerchantCopies ?? 0;
        const cNo = this.posCustomerCopies ?? 0;
        const itemRetId = itemReturnId ?? 0;
        let params =
          `methodname=${methodName}&param1=${param1}&param2=${param2}&uniqueSessionId=${session}&ReceiptHead=true&itemReturnId=${itemRetId}`;

        if (cardAmount > 0) {
          params += `&MerchantCopy=${mCopy}&CustomerCopy=${cCopy}&MerchantNoOfCopies=${mNo}&CustomerNoOfCopies=${cNo}`;
        }

        // Final URL
        const customProtocolUrl = `silentprinter://?${params}`;
        window.location.href = customProtocolUrl;
      }
    };

    // Print-only to a thermal printer: skip the server PDF generation (several seconds) and print right away
    if (print && this.printThermalReceipt && !display && !email) {
      this.loaderIcon = Promise.resolve(false);
      launchThermalPrint();
      return;
    }

    // Handle Receipt
    if (display || print || email) {
      generateAndProcessPDF(
        'Receipt',
        display,
        print,
        email,
        2,
        'Sales Receipt'
      );
    }
  }

  private sendEmail(
    accountReceiptId: number,
    baseTemplateId: number,
    message: string,
    fileName: string,
    subject: string,
    invoiceNo: number,
    CustomerEmailAdd: string
  ) {
    const emailData = [{
      AccountReceiptID: accountReceiptId,
      VendorID: 0,
      BaseTemplateID: baseTemplateId,
      AttachmentFile: message,
      AttachmentFileName: fileName,
      FileType: "application/pdf",
      Subject: subject,
      InvoiceNo: invoiceNo,
      POSCustomerEmail: CustomerEmailAdd
    }];

    this.customerEmailAdd = "";
    this.generalService.composeEmails(emailData).subscribe((res) => {
      if (res && res.Success)
        this.toastr.success($localize`Email sent successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
      else
        this.toastr.error($localize`Error while emailing invoice`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
    }, err => {
      this.toastr.error($localize`Error while emailing invoice`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
    });
  }

  private showPDFModal(base64Data: string) {
    this.loading = true;
    const modalId = 'printReceiptPopup';
    const pdfVar = 'receiptUrl';

    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      let modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (!modalInstance) {
        modalInstance = new window['bootstrap'].Modal(modalEl);
      }
      modalInstance.show();
    }

    const pdfBase64 = base64Data.split(',')[1];
    const blob = this.base64ToBlob(pdfBase64, 'application/pdf');
    this[pdfVar] = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.loading = false;
  }

  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type });
  }

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  sort(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.consignmentItems.sort((a, b) => {
      let valueA = a[column] ?? '';
      let valueB = b[column] ?? '';

      if (typeof valueA === 'string') valueA = valueA.toLowerCase();
      if (typeof valueB === 'string') valueB = valueB.toLowerCase();

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  resetAndLoad(): void {
    this.consignmentItems = [];
    this.getConsignmentProductForPOS();
  }

  ngOnDestroy(): void {
    this.cancelResetValues();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
